
//console.log("VISOR WMTS");


class Visor2D {
	constructor() {

		this.DEFAULT_POINT_VERTICES_NUMBER = 6;

		// this.there_are_dots = false;
		this.points_features = [];
		this.points_features_hashes = [];
		this.buildings_features = [];
		this.buildings_features_hashes = [];
		this.drawed_features = [];
		this.drawed_features_points = [];
		this.leyenda_button = $("#leyenda");
		this.sidebar_table = $("#pygeoapi-table-data");
		this.community_radius = 5000;
		this.filtered_table_data = null;
		this.buildingsID = []

		this.REPROJECT = 0;
		this.NO_REPROJECT = 1;

		this.RENDERING_POINTS = "P";
		this.RENDERING_BUILDINGS = "B";
		this.current_rendering_mode = this.RENDERING_POINTS;

		this.filtro_content = $("#filtro-content");
		this.filtro_content.addClass("d-none");

		this.vida_util = 25;
		this.eficiencia = 21;
		this.consumoP1Default = 65;
		this.consumoP2Default = 70;
		this.consumoP3Default = 133;
		this.consumoSolarDefault = [this.consumoP1Default, this.consumoP2Default, this.consumoP3Default].reduce((a, b) => a + b, 0);
		this.precioP1Default = 0.21;
		this.precioP2Default = 0.15;
		this.precioP3Default = 0.12;
		this.precioCompensacionDefault = 0.05;
		this.perdidaTemp = 0.4;
		this.perdidasGenerales = 10;
		this.consumoP1 = this.consumoP1Default;
		this.consumoP2 = this.consumoP2Default;
		this.consumoP3 = this.consumoP3Default;
		this.consumoSolar = this.consumoSolarDefault;
		this.precioP1 = this.precioP1Default;
		this.precioP2 = this.precioP2Default;
		this.precioP3 = this.precioP3Default;
		this.precioCompensacion = this.precioCompensacionDefault;
		this.produccionSolar = 0;
		this.produccionSolarFiltrado = 0;
		this.largoPanel = 1;
		this.anchoPanel = 2;
		this.ahorroCompensacion = 0;
		this.amortizacion = 0;
		this.costeManoObraDefault = 17;
		this.costePanelesDefault = 150;
		this.costeManoObra = this.costeManoObraDefault;
		this.costePaneles = this.costePanelesDefault;
		this.primerClickConsumo = true;
		this.pointsCounter = 0;

		this.current_table_data = {
			superficie: 0,
			valor_medio: 0,
			valor_minimo: 0,
			valor_maximo: 0,
			valor_total: 0,
		}

		this.filtered_table_data = {
			superficie: 0,
			valor_medio: 0,
			valor_minimo: 0,
			valor_maximo: 0,
			valor_total: 0,
		}

		this.ADDRESS = 0;
		this.REFERENCIA_CATASTRAL = 1;
		this.search_mode = this.ADDRESS;
		if (device_aspect === LAPTOP) {
			this.leyenda_button.removeClass("leyenda-hidden");
		}
		this.contrarios = {
			"radiacion_solar_global": "radiacion_solar_global",
			"radiacion_solar_media": "radiacion_solar",
			"radiacion_solar": "radiacion_solar_media",
			"IGNBaseTodo.tms": "pnoa.tms",
			"pnoa.tms": "IGNBaseTodo.tms",
		};
		this.layers = {
			orthofoto: new M.layer.TMS({
				url: 'https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg',
				name: 'pnoa.tms',
				projection: 'EPSG:3857',
				tileGridMaxZoom: 19,
			}),
			catastro: new M.layer.WMS(
				{
					url: "https://ovc.catastro.meh.es/cartografia/wms/servidorwms.aspx", // TODO: remove ssl
					name: "Catastro",
					legend: "Catastro",
					tiled: false,
					version: "1.1.1",
					useCapabilities: false
				}
			),
			raster: this.getRasterLayer(),
			solar_media: new M.layer.WMS({
				name: config.geoserver.wms.radiacion_solar_media.name,
				url: config.geoserver.wms.radiacion_solar_media.url,
				transparent: config.geoserver.wms.radiacion_solar_media.transparent,
				tiled: config.geoserver.wms.radiacion_solar_media.tiled,
				version: config.geoserver.wms.radiacion_solar_media.version,
				projection: config.geoserver.wms.radiacion_solar_media.projection,
				useCapabilities: false
			}),
			solar_media_publico: new M.layer.WMS({
				name: config.geoserver.wms.radiacion_solar_media_publico.name,
				url: config.geoserver.wms.radiacion_solar_media_publico.url,
				transparent: config.geoserver.wms.radiacion_solar_media_publico.transparent,
				tiled: config.geoserver.wms.radiacion_solar_media_publico.tiled,
				version: config.geoserver.wms.radiacion_solar_media_publico.version,
				projection: config.geoserver.wms.radiacion_solar_media_publico.projection,
				useCapabilities: false
			}),

			global_radiation: new M.layer.WMTS({
				url: config.geoserver.wms_global.url,
				matrixSet: config.geoserver.wms_global.matrixSet,
				layer: config.geoserver.wms_global.name,
				name: config.geoserver.wms_global.name,
				maxZoom: 21,
				format: config.geoserver.wms_global.format,
				useCapabilities: false,
				visibility: false
			}),
			radiacion_solar_puntos: null

		}

		this.buttons = {
			"search_input": $(".search-input-buttons")
		}
		this.inputs = {
			"layers": {
				"radiacion_solar": $("#Edificios"),
				"radiacion_solar_media": $("#building_h30_3042_index"),
				"radiacion_solar_media_publico": $("#solar_media_publico"),
				"radiacion_solar_global": $("#radiacion_solar_global"),
				"ortofoto": $("#pnoa-tms"),
				"baseign": $("#IGNBaseTodo-tms"),
				"catastro": $("#Catastro"),
			},
			"searchs": $(".search"),
			"search_type": $(".search-type"),
			"main_search": $("#search-mb")
		}
		this.default = {
			"x": -412277.8,
			"y": 4926708.8,
			"z": 14,
			"base": "IGNBaseTodo.tms",
			"radiacion": "radiacion_solar"
		}


	}
	init() {

		// load map
		this.map = this.instantiate_map();
		// load plugins
		this.add_plugins();
		// apply default layer according to Z
		// to avoid low resolution Imagen layer
		this.zoomChanged(this.default.z);
		// set proxy configuration
		// this.set_M_config();
		// add layers
		this.addLayersToMap();



		// handle events
		this.handle_apicnig_events();
		this.handle_html_events();

		//
		this.waitForPBFs();

		visor2D.loadVectorLayer([], "points", 1040);
		visor2D.layers.vector_points.on(M.evt.SELECT_FEATURES, (f) => {
			visor2D.deleteFeatureDots(f);
		});
	}

	// Delete feature from layer and points_features if different properties
	deleteFeatureDots(f) {
		if (selection_plugin.current_toggle_mode === selection_plugin.SELECTION_MODE_SUBSTRACT && $('#dot-less').hasClass('activated')) {
			visor2D.points_features = visor2D.points_features.filter(p => JSON.stringify(p.properties) != JSON.stringify(f[0].getGeoJSON().properties));
			visor2D.setVectorStyles(filterSlider.watios);
			visor2D.layers.vector_points.removeFeatures(visor2D.layers.vector_points.getFeatures().filter(p => JSON.stringify(p.getGeoJSON().properties) == JSON.stringify(f[0].getGeoJSON().properties)));
		}
	}


	handle_html_events() {
		this.addLayerInputsEvents();
		// this.addSearchInputsEvents();

		$(document).on("click", "#clear", () => {
			visor2D.clear_pygeoapy();
		});

		$(document).on("click", "#search-referencia-catastral", () => {
			const referencia_catastral = $("#input-referencia-catastral").val().substring(0, 14);

			let body = {
				'inputs': {
					'entidad': 'edificio',
					'limite': 1,
					"percentil": 100,
					'referencia_catastral': [referencia_catastral]
				}
			};

			const urlCatastro = `${config.pygeoapiCatastro.url}/items?f=json&lang=en-US&limit=10&properties=id_parcela,ogc_fid&additionalProp1=%7B%7D&skipGeometry=true&id_parcela=${referencia_catastral}`
			// const urlCatastro = `https://componentes.cnig.es/api-core/api/proxy?url=${config.pygeoapiCatastro.url}q=${referencia_catastral}&type=refcatastral&id=${referencia_catastral}`
			$.ajax({
				dataType: "json",
				url: urlCatastro,
				method: "GET",
				success: (data) => {
					if (data.features.length > 0) {
					// if (data) {
						const idBuilding = data.features[0].id;
						// const callback = data.content.replace("callback(", "").replace("})", "}");
						// const response = JSON.parse(callback);
						// const idBuilding = response.id;
						this.buildingsID.push(idBuilding);
						visor2D.fetchBuilding(body, undefined, true);
					}
				}
			});
		});

		$(document).on("click", "#m-ignsearchlocator-results-list > li", (e) => {
			const encoded_address = encodeURI(encodeURI(
				e.target.innerText
			))
			const url = `https://componentes.cnig.es/api-core/api/proxy?url=https%3A%2F%2Fwww.cartociudad.es%2Fgeocoder%2Fapi%2Fgeocoder%2FfindJsonp%3Fq%3D${encoded_address}`
			$.ajax({
				dataType: "json",
				url: url,
				method: "GET",
				success: (data) => {
					const callback = data.content.replace("callback(", "").replace("})", "}");
					const response = JSON.parse(callback);
					const coordinates = [response.lat, response.lng];
					visor3D.map.setProps({
						viewState: {
							latitude: coordinates[0],
							longitude: coordinates[1],
							zoom: 20,
							maxZoom: 21,
							pitch: 30
						}
					})
				}
			});
		});

		$("#return-to-filter").click(() => {
			selection_plugin.render_sidebar_filters();
		});

		this.inputs.search_type.on("change", function () {

			const current_input = $(this);
			const search_input = $(this).parent().parent().parent().parent().children().eq(0);

			if (current_input.val() === '0') {
				visor2D.search_mode = visor2D.ADDRESS;
				visor2D.inputs.main_search.attr("placeholder", "Escribe la dirección y localízalo...")
			} else {
				visor2D.search_mode = visor2D.REFERENCIA_CATASTRAL;
				visor2D.inputs.main_search.attr("placeholder", "Escribe la referencia catastral y localízalo...")
			}

			// address
			const search_input_val = search_input.val();

			if (!search_input_val) {
				return;
			}

			if (visor2D.search_mode === visor2D.ADDRESS) {
				visor2D.searchCandidates(search_input_val);
			} else { // referencia_catastral
				visor2D.searchCandidateCatastral(search_input_val);
			}

		});


		this.leyenda_button.click(
			(() => {
				if (this.leyenda_button.hasClass("leyenda-hidden")) {
					this.leyenda_button.removeClass("leyenda-hidden");
				} else {
					this.leyenda_button.addClass("leyenda-hidden");
				}
			}).bind(this)
		);


		$("#btn-simulacion").click(() => {

			if (this.primerClickConsumo) {

				// Valores de consumo según superficie
				const consumoTotal = this.current_table_data.superficie * 3;
				this.consumoP1Default = parseInt(consumoTotal * 0.24);
				this.consumoP2Default = parseInt(consumoTotal * 0.26);
				this.consumoP3Default = parseInt(consumoTotal * 0.49);

				$("#input-consumo-p1").val(this.consumoP1Default);
				$("#input-consumo-p2").val(this.consumoP2Default);
				$("#input-consumo-p3").val(this.consumoP3Default);

				$("#input-precio-p1").val(this.precioP1Default);
				$("#input-precio-p2").val(this.precioP2Default);
				$("#input-precio-p3").val(this.precioP3Default);
				$("#input-compensacion").val(this.precioCompensacionDefault.toFixed(2));
				$("#input-consumo-prod").val(this.consumoSolarDefault);

				this.primerClickConsumo = false;
			}

			if ($("#datos-consumo").hasClass("d-none"))
				$("#datos-consumo").removeClass("d-none");
		});

		$("#close-consumo").click(() => {
			if (!$("#datos-consumo").hasClass("d-none"))
				$("#datos-consumo").addClass("d-none");
		});

		$("#btn-consumo-reset").click(() => {

			this.consumoP1Default = this.current_table_data.superficie * 3 * 0.24;
			this.consumoP2Default = this.current_table_data.superficie * 3 * 0.26;
			this.consumoP3Default = this.current_table_data.superficie * 3 * 0.49;

			$("#input-consumo-p1").val(parseInt(this.consumoP1Default));
			$("#input-consumo-p2").val(parseInt(this.consumoP2Default));
			$("#input-consumo-p3").val(parseInt(this.consumoP3Default));

			$("#input-precio-p1").val(this.precioP1Default);
			$("#input-precio-p2").val(this.precioP2Default);
			$("#input-precio-p3").val(this.precioP3Default);

			$("#input-compensacion").val(this.precioCompensacionDefault);
			$("#input-consumo-prod").val(this.consumoSolarDefault);
		});

		$("#btn-config-reset").click(() => {
			$("#input-paneles").val(this.costePanelesDefault);
			$("#input-mano-obra").val(this.costeManoObraDefault);
		});

		$("#btn-consumo-calc").click(() => {
			$("#data-economics").html(this.getTableEconomicsHTML(this.current_table_data, this.filtered_table_data));
			if (!$("#datos-consumo").hasClass("d-none"))
				$("#datos-consumo").addClass("d-none");
		});

		$("#btn-config-cargar").click(() => {
			this.costeManoObra = parseFloat($("#input-mano-obra").val());
			this.costePaneles = parseFloat($("#input-paneles").val());

			this.current_table_data.price = this.calcularCosteInstalacion(this.current_table_data.superficie);
			this.filtered_table_data.price = this.calcularCosteInstalacion(this.filtered_table_data.superficie);
			this.aplicarConfiguracion();
			$("#data-economics").html(this.getTableEconomicsHTML(this.current_table_data, this.filtered_table_data));

			if (!$("#config-instalacion").hasClass("d-none"))
				$("#config-instalacion").addClass("d-none");
		});

		$("#btn-config").click(() => {

			$("#input-mano-obra").val(this.costeManoObra);
			$("#input-paneles").val(this.costePaneles);

			if ($("#config-instalacion").hasClass("d-none"))
				$("#config-instalacion").removeClass("d-none");
		});

		$("#close-config-instalacion").click(() => {
			if (!$("#config-instalacion").hasClass("d-none"))
				$("#config-instalacion").addClass("d-none");
		});

		$("#btn-consumo-opt").click(() => {
			this.optimizar(1);
		});

		$("#btn-amort-opt").click(() => {
			this.optimizar(2);
		});

		$("#close-rad").click(() => {
			if (!$("#rad-anual").hasClass("d-none"))
				$("#rad-anual").addClass("d-none");
		});

		$("#close-optima").click(() => {
			if (!$("#ubicacion-optima").hasClass("d-none"))
				$("#ubicacion-optima").addClass("d-none");
		});

		$("#btn-ubicacion-opt").click(() => {
			if ($("#ubicacion-optima").hasClass("d-none"))
				$("#ubicacion-optima").removeClass("d-none");
		});

		$("#btn-ubicacion-calc").click(() => {
			$("#ubicacion-optima").addClass("d-none");
			this.ubicacionPaneles(this.obtenerBodyUbicacion());
		});

		$("#btn-ubicacion-calc-opt").click(() => {
			$("#ubicacion-optima").addClass("d-none");
			this.ubicacionOptima(this.obtenerBodyUbicacion());
		});

		$("#input-tecnologia").on("change", () => {
			let tecnologia = parseInt($("#input-tecnologia").val());

			switch (tecnologia) {
				case 1:
					this.eficiencia = 21;
					this.perdidaTemp = 0.4;
					break;
				case 2:
					this.eficiencia = 22;
					this.perdidaTemp = 0.35
					break;
				case 3:
					this.eficiencia = 22.5;
					this.perdidaTemp = 0.33;
					break;
				case 4:
					this.eficiencia = 23;
					this.perdidaTemp = 0.25;
					break;
				case 5:
					this.eficiencia = 23.5;
					this.perdidaTemp = 0.33;
					break;
				case 6:
					this.eficiencia = 18;
					this.perdidaTemp = 0.45;
					break;
				case 7:
					this.eficiencia = 19;
					this.perdidaTemp = 0.4;
					break;
				case 8:
					this.eficiencia = 14;
					this.perdidaTemp = 0.35;
					break;
				case 9:
					this.eficiencia = 11.5;
					this.perdidaTemp = 0.3;
					break;
				default:
					this.eficiencia = 21;
					this.perdidaTemp = 0.4;
					break;
			}

			$('#input-eficiencia').val(this.eficiencia);
		});
	}

	render_drawed_polygons() {

		// merge them all
		visor2D.drawed_features.map((e, id) => { e.id = id; })
		this.features_grouped_by_touch = Utils.geometry.group_by_intersection(visor2D.drawed_features);
		visor2D.drawed_features = Utils.geometry.mergeGroups(this.features_grouped_by_touch);

		// substract if neccessary
		if (visor2D.substract_feature !== undefined) {
			visor2D.drawed_features = Utils.geometry.difference(visor2D.drawed_features, visor2D.substract_feature);
			visor2D.substract_feature = undefined;
		}

		visor2D.loadVectorLayer(visor2D.drawed_features, "drawed", 1036);
	}
	clear_pygeoapy() {
		const layers = Object.keys(visor2D.layers).filter(e => e.includes("vector_"));

		visor2D.filtro_content.addClass("d-none");
		visor2D.sidebar_table.html("");
		collapseSidebar();

		visor2D.current_table_data = {
			superficie: 0,
			valor_medio: 0,
			valor_minimo: 0,
			valor_maximo: 0,
			valor_total: 0,
		}

		visor2D.points_features = [];
		visor2D.points_features_hashes = [];
		visor2D.buildings_features = [];
		visor2D.buildings_features_hashes = [];
		visor2D.drawed_features = [];
		visor2D.drawed_features_points = [];
		for (const layer of layers) {
			visor2D.map.removeLayers(visor2D.layers[layer]);
			visor2D.layers[layer] = undefined;
		}

		// Remove WMS layer
		visor2D.map.removeLayers(visor2D.layers.radiacion_solar_puntos);

		// null RENDERING MODE
		selection_plugin.toggle_points_tool_visibility(true);
		visor2D.current_rendering_mode = visor2D.RENDERING_POINTS;

		// Remove buildings IDs
		visor2D.buildingsID = [];
	}
	add_plugins() {

		this.mp = new M.plugin.SelectionDraw({
			projection: 'EPSG:4326',
			position: 'TR',
			collapsed: false,
			collapsible: true,
		});
		this.map.addPlugin(this.mp);
		const ignsearchBtn = setInterval(() => {
			Utils.checkAndClear("#m-ignsearchlocator-clean-button", (btnElement) => {
				btnElement.html(btnElement.html().replace('Eliminar', ''));

				$('.m-areas').insertAfter('#layers-button-parent');
				$('.m-areas').addClass("m-mapea-container");

				const grid_class = `display: grid !important; grid-template-columns: 15% 85%;`;
				$(".m-panel.m-selectiondraw").attr('style', grid_class);

			}, ignsearchBtn);
		}, 50);

		this.map.getMapImpl().on('rendercomplete', () => {

			var intro;
			var widget = [ //array con los títulos y el, para escribirlos una sola vez y asegurar su integridad
				{ tit: "Menú principal ayuda flotante", id_icon: undefined, el: undefined }, //0
				{ tit: "Buscar dirección o lugar", id_icon: "lupaIcon", el: document.getElementById('m-ignsearch-panel') }, //1
				{ tit: "Acceso al cuadro de mandos", id_icon: "speedIcon", el: document.querySelector('#superset-link') }, //2
				{ tit: "Compartir", id_icon: "compartirIcon", el: document.querySelector('.navbar-toggler.d-inline.share') }, //3
				{ tit: "Información", id_icon: "infoIcon", el: document.querySelector('.navbar-toggler.d-inline.info') }, //4
				{ tit: "Ayuda flotante", id_icon: "tourIcon", el: document.getElementById('nav-help-button') }, //5
				{ tit: "Selección de edificios", id_icon: "building-plus_tour", el: document.querySelector('button#building-tool') }, //6
				{ tit: "Selección de puntos ", id_icon: "dot-plus", el: document.querySelector('button#points-tool') }, //7
				{ tit: "Selección de polígonos", id_icon: "polygon-plus", el: document.getElementById('polygon-tool') }, //8
				{ tit: "Consulta de comunidades energéticas", id_icon: "community", el: document.getElementById('community') }, //9
				{ tit: "Eliminar búsqueda", id_icon: "binIcon", el: document.querySelector('.g-plugin-selectordraw-papelera') }, //10
				{ tit: "Buscar por referencia catastral", id_icon: "lupaIcon", el: document.querySelector('#referencia-catastral') }, //11
				{ tit: "Capas de información geográfica", id_icon: "CapasIcon", el: document.querySelector('.layersbutton1.rounded-circle.skewbutton.clickable#layers-button1') }, //12
				{ tit: "Vista 3D", id_icon: "boxes", el: document.getElementById('map-dimension-toggler-button') }, //13
				{ tit: "Leyenda", id_icon: "LegendIcon", el: document.querySelector('.position-absolute.noselect') }, //14
				{ tit: "Filtro de radiación", id_icon: "filtroIcon", el: document.querySelector('.mb-1.noselect.mb-5') }, //15
				{ tit: "Indicadores de energía", id_icon: "tablaIcon", el: document.querySelector('#button-collapse4') }, //16
				{ tit: "Evolución de la radiación", id_icon: "graficaIcon", el: document.querySelector('#button-collapse3') }, //17
				{ tit: "Indicadores económicos", id_icon: "euroIcon", el: document.querySelector('#button-collapse2') }, //18

			]



			var numIndex = 2; //porque el 1 es la página del índice, así que el li empieza en 2

			/*función que genera los div de los widgets visibles de la aplicación de manera dinámica, para mostrarlos en la pantalla de inicio
				Recibe: el array de configuración de los widgets
				Devuelve: El array con los div que están visibles en la app
			*/

			var create_div = function (array) {
				var arraySteps = [];
				for (let i = 1; i < array.length; i++) {
					// if ($(array[i].el).is(':visible')) {
					let str = (array[i].id_icon) ? "<div class='iconIndice' id='" + array[i].id_icon + "'></div>" : "";
					arraySteps.push("<div class='lineaIndice'>" + str + "<a href='javascript:go_introjs(" + numIndex + ");'>" + array[i].tit + "</a></div>");
					numIndex++; //solo pasa de número de índice si se añade el li, si no se añade, sigue igual
					// }
				}
				return arraySteps;
			}



			let arrayDiv = create_div(widget);
			let div1 = arrayDiv.splice(0, Math.round(arrayDiv.length / 2));
			let div2 = arrayDiv.splice(0, arrayDiv.length);

			intro = introJs().setOptions({
				showSkipButton: true,
				hidePrev: true,
				hideNext: true,
				nextLabel: '<span class="material-icons">></span>',
				prevLabel: '<span class="material-icons"><</span>',
				skipLabel: '<span class="material-icons">x</span>',
				doneLabel: '<span class="material-icons">x</span>',
				steps: [ //pag 1
					{
						title: widget[0].tit,
						view: true,
						intro: "<div class='container'>" +
							"<div class='introjs-tooltiptext-div div1'>" +
							div1.join("") +
							"</div><div class='introjs-tooltiptext-div div2' start='" + (div1.length + 1) + "'>" +
							div2.join("") +
							"</ol>" +
							"</div>",
					},
					{ //pag 2
						element: widget[1].el,
						title: widget[1].tit,
						intro: "Permite realizar búsquedas para centrar la vista del mapa en el lugar deseado: direcciones, topónimos, códigos postales y referencias catastrales. Utiliza el Geocodificador del Instituto Geográfico Nacional"

					},
					{//pag 3
						element: widget[2].el,
						title: widget[2].tit,
						intro: "Se muestra el potencial solar estimado e instalado en diferentes pestañas, a nivel municipal, provincial y nacional. Permite hacer filtros por un municipio o provincia concreta. Se ha obtenido de diferentes fuentes de datos, que también se pueden alternar."

					},
					{//pag 4
						element: widget[3].el,
						title: widget[3].tit,
						intro: "Permite compartir lo que se está visualizando en la pantalla del visualizador. Se comparte el ámbito geográfico y las capas activas."


					},
					{ //pag 5
						element: widget[4].el,
						title: widget[4].tit,
						intro: 'Abre un panel de información sobre el visualizador. Además, se indica el correo electrónico de contacto para cualquier información o consulta que el usuario necesite.',

					},
					{ //pag 6
						element: widget[5].el,
						title: widget[5].tit,
						intro: "Permite recorrer secuencialmente las herramientas o bien acceder directamente a una funcionalidad concreta desde el menú principal de la ayuda. "

					},
					{ //pag 7
						element: widget[6].el,
						title: widget[6].tit,
						intro: "Estos botones del panel permiten:" +
							"<ul class='introjs-tooltiptext-ul'>" +
							"<li>Agregar edificios a la selección (botón superior).</li>" +
							"<li>Eliminar edificios de la selección (botón inferior).</li>" +
							"</ul>" +
							"Al seleccionar uno o varios edificios, en el mapa se muestra la radiación solar que incide sobre la cubierta del edificio."
					},
					{ //pag 8
						element: widget[7].el,
						title: widget[7].tit,
						intro: "Estos botones del panel permiten:" +
							"<ul class='introjs-tooltiptext-ul'>" +
							"<li>Agregar puntos a la selección (botón superior).</li>" +
							"<li>Eliminar puntos de la selección (botón inferior).</li>" +
							"</ul>" +
							"Cada punto que se selecciona añade a la consulta una nueva celda de 2 x 2 metros."
					},
					{ //pag 9
						element: widget[8].el,
						title: widget[8].tit,
						intro: "Estos botones del panel permiten:" +
							"<ul class='introjs-tooltiptext-ul'>" +
							"<li>Agregar polígonos a la selección (botón superior).</li>" +
							"<li>Eliminar polígonos de la selección (botón inferior).</li>" +
							"</ul>" +
							"Existen ocasiones en las que, dada la irregularidad de las cubierta del edificio o la elevada extensión de la misma no es sencillo seleccionar todos los puntos a consultar. " +
							"Es por ello que se ha añadido el dibujo libre como herramienta de selección, de forma que se pueda dibujar un polígono sobre la superficie de un edificio y así realizar la consulta deseada.",
						position: "bottom"
					},
					{ //pag 10
						element: widget[9].el,
						title: widget[9].tit,
						intro: "Las comunidades energéticas son grupos de personas que comparten el interés en generar energía renovable, como la solar, para su propio consumo. Colaboran en la producción, almacenamiento y distribución de esta energía para promover la sostenibilidad y eficiencia en el uso de recursos. " +
								"<p>Este botón del panel de herramientas dibuja un radio de 5 km alrededor del punto seleccionado, como referencia espacial para identificar posibles ámbitos de proximidad en determinados supuestos de autoconsumo colectivo. Esta distancia fue introducida en el <a href='https://www.boe.es/buscar/act.php?id=BOE-A-2026-6544' target='_blank'>Real Decreto-ley 7/2026</a>.</p>",
						position: 'bottom'
					},
					{ //pag 11
						element: widget[10].el,
						title: widget[10].tit,
						intro: "Con este botón se eliminarán todas las consultas realizadas. Es decir, de edificios, puntos y polígonos. Se mostrará el mapa como al inicio."
					},
					{ //pag 12
						element: widget[11].el,
						title: widget[11].tit,
						intro: "Con este último elemento del panel de herramientas de selección se puede buscar un edificio a través de la referencia catastal del mismo." +
							"La referencia catastral debe constar de 14 dígitos sin espacios, que son el identificador de finca o parcela y la hoja del plano. Por ejemplo: 9977715VK3797F"
					},
					{ //pag 13
						element: widget[12].el,
						title: widget[12].tit,
						intro: "Este panel permite:" +
							"<ul class='introjs-tooltiptext-ul'>" +
							"<li>Activar/desactivar las capas.</li>" +
							"<li>Aplicar transparencia a una de las capas.</li>" +
							"<li>Seleccionar una de las capas de fondo: mapa o imagen.</li>" +
							"<li>Mostrar la capa del Catastro.</li>" +
							"</ul>" +
							"Solo una capa se puede activar como visible. Las capas disponibles son:" +
							"<ul class='introjs-tooltiptext-ul'>" +
							"<li>Radiación solar (activa por defecto), que muestra la radiación solar de las cubiertas de los edificios.</li>" +
							"<li>Radiación solar media, muestra la media de la radiación solar que incide sobre las cubiertas de los edificios.</li>" +
							"<li>Edificios públicos, esta capa muestra la radiación solar de las cubiertas de edificios públicos.</li>" +
							"<li>Radiación solar global, muestra la radiación solar que llega a la superficie.</li>" +
							"</ul>",
					},
					{ //pag 14
						element: widget[13].el,
						title: widget[13].tit,
						intro: "Seleccionando esta herramienta podemos cambiar a modo de visualización en 3D. " +
							"Se representarán los edificios en tres dimensiones, con la cubierta del edificio coloreada según el potencial solar medio. " +
							"En el visor 3D, es posible cambiar el ángulo de vista, para ello, mantener pulsado en el mapa el botón derecho del ratón y mover el ratón hacia la dirección en la que se quiere mover la vista. "
						// "Si se activa esté botón se desactiva la herramienta de: capas de información geográfica y se oculta el panel de la izquierda."

					},
					{ //pag 15
						element: widget[14].el,
						title: widget[14].tit,
						intro: "En la esquina inferior derecha se situa la leyenda del mapa. Al hacer click sobre ella, aparecerá o desaparecerá."

					},
					{ //pag 16
						element: widget[15].el,
						title: widget[15].tit,
						intro: "Una vez se realiza la selección de puntos, edificios o polígonos, se presenta la información del potencial solar y los costes de la instalación fotovoltaica. " +
							"Utilizar esta barra para filtrar el valor mínimo del potencial solar anual de los puntos que se van a mostrar. "
					},
					{ //pag 17
						element: widget[16].el,
						title: widget[16].tit,
						intro:
							"Se recogen en una tabla los distintos valores de potencial solar, energía, producción y potencia que se obtendrían para la cubierta o cubiertas seleccionadas. Los datos mostrados son: " +

							"<ol class='introjs-tooltiptext-ol'>" +
							"<li>Superficie: superficie en metros cuadrados de la selección</li>" +
							"<li>Valor medio anual: energía solar media de la superficie, expresada en KW/m<sup>2</sup></li>" +
							"<li>Valor mímimo anual: energía solar del punto de menor potencial</li>" +
							"<li>Valor máximo anual: energía solar del punto de mayor potencial</li>" +
							"<li>Energía solar acumulada: energía total que recibe la totalidad de la cubierta a lo largo de una año</li>" +
							"<li>Producción fotovoltaica anual: energía fotovoltaica producida a lo largo de un año.</li>" +
							"<li>Potencia máxima: potencia máxima capaz de generar la instalación fotovoltaica.</li>" +
							"</ol>",
						position: "right"
					},
					{ //pag 18
						element: widget[17].el,
						title: widget[17].tit,
						intro: "Se muestra un gráfico que recoge la radiación solar media de cada mes para todos los puntos, así como la media anual de radiación solar.",
						position: "right"
					},
					{ //pag 19
						element: widget[18].el,
						title: widget[18].tit,
						intro: "La aplicación realiza un cálculo sobre cuales serían los costes resultantes de una instalación fotovoltaica. Dentro de este apartado existen diferentes funcionalidades: introducir datos de consumo, configuración de la instalación, calcular autoconsumo y calcular mímina amortización",
						// "<ol class='introjs-tooltiptext-ol'>"+
						// 	"<li> Se abrirá un formulario que por defecto contiene valores obtenidos a partir de los datos medios de consumo en España. </li>"+
						// 	"Se podrán introducir valores propios, estos valores se pueden encontrar en una factura de la comercializadora de electricidad. Al cargar los datos se reculacularán los indicadores economicos teniendo en cuenta los nuevos datos."+
						// 	"<li>Se podrñan modificar multiples valores: tecnología de paneles, eficiencia del sistema o las pérdidas. También se podrán ajustar costes de mano de obra o de los paneles.</li>"+
						// 	"<li>Realiza un cálculo en el que se obtienen los puntos cuya suma de potenciales compensa el consumo. De forma que, se piede conocer el coste estimado de la instalación que generaría un consumo igual a la producción</li>"+
						// 	"<li>:Se podrá obtener un cálculo de cual sería el menor periodo de amortización de la instalación</li>"+
						// "</ol>",
						position: "right"
					},

				]
			})

			document.getElementById('nav-help-button').onclick = () => {
				try {
					if (document.querySelector('.menu.d-flex.bg-light.px-2.py-3.collapsed')) {
						document.getElementById('sidebar-tab').click()
					}
					if (document.querySelector('.m-panel.m-selectiondraw.collapsed')) {
						document.querySelector('.m-panel-btn.h-100.g-plugin-selectordraw-editar').click()
					}

					if (intro._currentStep != null) {
						intro.exit(); // 🔁 Sal del tour si ya estaba en ejecución
					}
					intro.start(); // ✅ Reutiliza la instancia ya configurada

				} catch {

				}

			};
			try {
				document.getElementById('startHelp').onclick = () => {
					document.querySelector('.closemodal').click()
					intro.start();
				};
			} catch {

			}


			// Agregar botón personalizado "Ir al Primer Paso"
			intro.onafterchange(function (targetElement) {

				const firstStepButton = document.createElement('button');
				firstStepButton.classList.add('introjs-button', 'introjs-center');
				firstStepButton.innerText = 'Ir al menú de la ayuda';
				firstStepButton.onclick = function () {
					intro.goToStep(1); // Redirigir al primer paso
				};




				// Asegurarse de que el botón solo se agregue una vez
				const existingButton = document.querySelector('.introjs-button.introjs-center');
				if (!existingButton) {
					try {
						document.querySelector('.introjs-prevbutton').parentNode.appendChild(firstStepButton);
					} catch {

					}
				}

				if (intro._currentStep === 0) {
					try {
						document.querySelector('.introjs-button.introjs-center').style.visibility = 'hidden'
					} catch {

					}

				} else {
					try {
						document.querySelector('.introjs-button.introjs-center').style.visibility = 'visible'
					} catch {

					}

				}



			});


			const go_introjs = (num) => {
				intro.goToStepNumber(num);
			}

			window.go_introjs = go_introjs;

			window.intro = intro;








			// window.go_start = go_start;

		});




		//const ignsearchCargado = setInterval(() => {
		//	Utils.checkAndClear("#m-locator-ignsearch", (locatorElement) => {
		//		locatorElement.click();
		//	}, ignsearchCargado);
		//}, 50);
		const input_locator = setInterval(() => {
			Utils.checkAndClear(".m-panel-controls", () => {
				const input = $(`<div class="">
				<div id="referencia-catastral" class="position-absolute w-100 d-flex bg-light justify-content-center align-items-center p-1">
					<div class="px-2 clickable" id="search-referencia-catastral">
						<i class="bi bi-search"></i>
					</div>
					<input class="form-control" placeholder="Referencia catastral" id="input-referencia-catastral" maxlength="20">
				</div>
			</div>`)
				$($('.m-panel-controls').get(1)).after(input);
			}, input_locator);
		}, 50);

		this.addControlsToMap();
	}
	zoomChanged(zoom) {

		if (typeof Chart === 'undefined') {
			return;
		}

		window.zoom = zoom;
		if (zoom > 17) {
			if (visor2D.layers.ignbasetodo.isVisible()) {
				visor2D.layers.ignbasetodoWMTS.setVisible(true)
			} else {
				visor2D.layers.ignbasetodoWMTS.setVisible(false);
				if (window.PnoaMessage) {
					M.dialog.info("Tenga en cuenta que la imagen puede tener deformaciones debido a la altura del edificio");
					window.PnoaMessage = false;
				}
			}
		} else {
			visor2D.layers.ignbasetodoWMTS.setVisible(false);
		}

		visor2D.setVectorStyles(filterSlider.watios);

	}
	findBoundingBox(response) {

		let minX = Number.POSITIVE_INFINITY;
		let minY = Number.POSITIVE_INFINITY;
		let maxX = Number.NEGATIVE_INFINITY;
		let maxY = Number.NEGATIVE_INFINITY;


		if (response.bbox) {

			const bbox = response.bbox;

			minX = Math.min(bbox[0], bbox[2]);
			maxX = Math.max(bbox[0], bbox[2]);
			minY = Math.min(bbox[1], bbox[3]);
			maxY = Math.max(bbox[1], bbox[3]);

		} else {

			const polygon = response.features[0].geometry.coordinates
			const coordinates = [].concat(...polygon.map(arrays => [].concat(...arrays)));

			if (coordinates.length === 0) {
				return null; // Handle empty input case
			}

			for (const [x, y] of coordinates) {
				minX = Math.min(minX, x);
				minY = Math.min(minY, y);
				maxX = Math.max(maxX, x);
				maxY = Math.max(maxY, y);
			}

		}


		return [minX, minY, maxX, maxY];
	}
	getRasterLayer() {
		if (config.geoserver.wmts.matrixSet === undefined) {
			return new M.layer.WMTS(
				{
					url: config.geoserver.wmts.url,
					name: config.geoserver.wmts.name,
					version: config.geoserver.wmts.version,
					format: config.geoserver.wmts.format,
					useCapabilities: false
				},
				{
					format: config.geoserver.wmts.format
				}
			)
		}
		return new M.layer.WMTS(
			{
				url: config.geoserver.wmts.url,
				name: config.geoserver.wmts.name,
				version: config.geoserver.wmts.version,
				format: config.geoserver.wmts.format,
				matrixSet: config.geoserver.wmts.matrixSet,
				maxZoom: 21,
				useCapabilities: false
			},
			{
				format: config.geoserver.wmts.format
			}
		)
	}
	waitForPBFs() {
		this.waitForRaster = setInterval(() => {

			let olLayer = visor2D.layers.raster.getImpl().getOL3Layer();
			if (!olLayer) {
				return;
			}

			let raster_layer = visor2D.map.getWMTS().filter(x => x.name == config.geoserver.wmts.name)[0];
			raster_layer.setOpacity(0.5);
			clearInterval(visor2D.waitForRaster);

		}, 100);
	}
	customStyleFunction = function (feature, only_stroke) {

		const type = feature.values_["type"];
		const size = feature.values_["size"];


		if (type === 'building') {
			return new ol.style.Style({
				fill: new ol.style.Fill({
					color: [255, 255, 255, .8]
				}),
				stroke: new ol.style.Stroke({
					color: [90, 90, 90, .5],
					// color: [255, 204, 38, 0.6],
					width: 1
				})
			});
		}
		if (type === 'radius') {
			const bg_color = (size === "big") ? [255, 216, 126, .4] : [126, 214, 255, .2];
			return new ol.style.Style({
				fill: new ol.style.Fill({
					color: bg_color
				}),
				stroke: new ol.style.Stroke({
					color: [90, 90, 90, .5],
					// color: [255, 204, 38, 0.6],
					width: 1
				})
			});
		}


		const dot_value = feature.values_["value_anual"];
		let colors = [
			[125, "#4d244e"],
			[250, "#5f2855"],
			[375, "#712b5a"],
			[500, "#842f5d"],
			[625, "#96335f"],
			[750, "#a8385f"],
			[875, "#b93f5e"],
			[1000, "#c9465b"],
			[1125, "#d85057"],
			[1250, "#e65b52"],
			[1375, "#f1684c"],
			[1500, "#fb7644"],
			[1625, "#ff853c"],
			[1750, "#ff9532"],
			[1875, "#ffa626"],
			[2000, "#ffb717"],
			[2125, "#ffc900"],
			[2250, "#ffdb00"],
			[2375, "#ffed00"],
		];
		colors = colors.reverse();


		let dot_color = "#000000";


		if (dot_value) {
			for (const color of colors) {
				let value = color[0];
				if (dot_value > value - 125 && dot_value < value + 125) {
					dot_color = color[1];
					// break;
				}
			}
		}

		if (only_stroke) {
			return new ol.style.Style({
				fill: new ol.style.Fill({
					color: [0, 0, 0, 0],
				}),
				stroke: new ol.style.Stroke({
					color: dot_color,
					width: 1
				})
			});
		}

		const radious_dict = {
			"22": 30,
			"21": 14,
			"20": 7,
			"19": 3.5,
			"18": 2,
			"17": 1,
		}
		const radious = radious_dict[parseInt(window.zoom)] || 1;
		// const radious = radious_dict[window.zoom] || 1;

		if (type === 'solar-building') {
			return new ol.style.Style({

				// image: new ol.style.Circle({
				// 	radius: radious,
				// 	fill: new ol.style.Fill({ color: dot_color }),
				// 	stroke: new ol.style.Stroke({
				// 		color: [90, 90, 90, .5],
				// 		width: 1
				// 	})

				// }),
				fill: new ol.style.Fill({
					color: dot_color
				}),
				stroke: new ol.style.Stroke({
					color: [90, 90, 90, .5],
					width: 1
				})
			});
		}

		return new ol.style.Style({

			image: new ol.style.Circle({
				radius: radious,
				fill: new ol.style.Fill({ color: dot_color }),
				stroke: new ol.style.Stroke({
					color: [90, 90, 90, .5],
					width: 1
				})

			}),
			// fill: new ol.style.Fill({
			// 	color: dot_color
			// }),
			// stroke: new ol.style.Stroke({
			// 	color: [90, 90, 90, .5],
			// 	width: 1
			// })
		});

	}
	emptyStyle() {
		// return empty style
		return new ol.style.Style({
			fill: new ol.style.Fill({
				color: [0, 0, 0, 0],
			}),
			stroke: new ol.style.Stroke({
				color: [255, 204, 38, 0.6],
				width: 1
			})
		})
	}
	setVectorStyles(watios) {


		if (visor2D.layers.vector_community) {
			let olPointsLayer = visor2D.layers.vector_community.getImpl().getOL3Layer();
			if (olPointsLayer === null) {
				visor2D.map.removeLayers(visor2D.layers.vector_community);
				visor2D.map.addLayers(visor2D.layers.vector_community);
				olPointsLayer = visor2D.layers.vector_community.getImpl().getOL3Layer();
			}

			// set style
			olPointsLayer.setStyle(function (t, e) {
				return visor2D.customStyleFunction(t);
			});
		}


		if (visor2D.layers.vector_points) {

			// get OL layer
			let olPointsLayer = visor2D.layers.vector_points.getImpl().getOL3Layer();
			if (olPointsLayer === null) {
				visor2D.map.removeLayers(visor2D.layers.vector_points);
				visor2D.map.addLayers(visor2D.layers.vector_points);
				olPointsLayer = visor2D.layers.vector_points.getImpl().getOL3Layer();
			}

			// set style
			olPointsLayer.setStyle(function (t, e) {
				if (watios < t.values_["value_anual"] || t.values_["value_anual"] === undefined) {
					return visor2D.customStyleFunction(t);
				} else {
					return visor2D.emptyStyle();
				}
			});

		}

		if (visor2D.layers.vector_buildings) {
			let olBuildingLayer = visor2D.layers.vector_buildings.getImpl().getOL3Layer();
			if (olBuildingLayer === null) {
				visor2D.map.removeLayers(visor2D.layers.vector_buildings);
				visor2D.map.addLayers(visor2D.layers.vector_buildings);
				olBuildingLayer = visor2D.layers.vector_buildings.getImpl().getOL3Layer();
			}

			// set style
			olBuildingLayer.setStyle(function (t, e) {
				if (watios < t.values_["value_anual"] || t.values_["value_anual"] === undefined) {
					return visor2D.customStyleFunction(t);
				} else {
					return visor2D.customStyleFunction(t, true);
				}
			});
		}




		// filtered points
		let points_table_html = '';
		let economicsTableHTML = 'No hay datos';

		const left_points = visor2D.points_features.filter(
			item => item.properties.value_anual >= watios
		);

		if (left_points.length === 0) {
			points_table_html = 'No hay datos.'
		} else {
			// // calc statistics variables
			const values = left_points.map(dict => dict.properties.value_anual);
			const minValue = Math.min(...values);
			const maxValue = Math.max(...values);
			const avgValue = values.reduce((sum, value) => sum + value, 0) / values.length;
			const surface = left_points.length * 4;
			const filtered_table_data = {
				superficie: surface,
				valor_medio: avgValue,
				valor_minimo: minValue,
				valor_maximo: maxValue,
				valor_total: surface * avgValue,
			}

			// create html
			points_table_html = visor2D.getTableHTML(
				visor2D.current_table_data, filtered_table_data
			)

			economicsTableHTML = this.getTableEconomicsHTML(this.current_table_data, filtered_table_data);
		}

		$("#data-economics").html(economicsTableHTML);
		this.abrirGrafico(left_points);

		let buildings_table_html = ''
		const left_buildings = visor2D.buildings_features.filter(
			item => item.properties.value_anual >= watios
		);

		if (left_buildings.length === 0) {
			buildings_table_html = 'No hay datos.'
		} else {

			const building_values = left_buildings.map(dict => dict.properties.value_anual);

			const minBuildingsValue = Math.min(...building_values);
			const maxBuildingsValue = Math.max(...building_values);
			const avgBuildingsValue = building_values.reduce((sum, value) => sum + value, 0) / building_values.length;
			let building_surface = left_buildings.reduce((sum, item) => sum + item.properties.surface, 0) * 1000;
			const filtered_table_data = {
				superficie: building_surface,
				valor_medio: avgBuildingsValue,
				valor_minimo: minBuildingsValue,
				valor_maximo: maxBuildingsValue,
				valor_total: building_surface * avgBuildingsValue,
			}

			buildings_table_html = visor2D.getTableHTML(
				visor2D.current_table_data, filtered_table_data
			)
		}

		visor2D.filtro_content.removeClass("d-none");
		if (visor2D.current_rendering_mode === visor2D.RENDERING_POINTS) {
			visor2D.sidebar_table.html(points_table_html);
		}
		if (visor2D.current_rendering_mode === visor2D.RENDERING_BUILDINGS) {
			visor2D.sidebar_table.html(buildings_table_html);
		}
		tippy('#superficie', {
			content: 'Superficie de la cubierta del edificio seleccionado en metros cuadrados.',
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
		tippy('#valor-medio-anual', {
			content: 'Energía solar media de la cubierta del edificio seleccionado expresada en kWh/m².',
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
		tippy('#valor-minimo-anual', {
			content: 'Energía solar obtenida en el punto de menor insolación de la cubierta del edificio seleccionado expresada en kWh/m².',
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
		tippy('#valor-maximo-anual', {
			content: 'Energía solar obtenida en el punto de mayor insolación de la cubierta del edificio seleccionado expresada en kWh/m².',
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
		tippy('#energia-solar-acumulada', {
			content: 'Total de la energía solar recibida al cabo del año en la cubierta completa del edificio seleccionado.',
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
		tippy('#inversion-tippy', {
			content: "No se incluye el coste del inversor ni reguladores o baterías. Tampoco se incluyen costes de legalización de la instalación.",
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
		tippy('#ahorro-vidautil-tippy', {
			content: "En el ahorro acumulado se tiene en cuenta el coste de la instalación, estimando una vida útil de 25 años.",
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
		tippy('#potencia-pico', {
			content: "Potencia máxima que puede generar la instalación fotovoltaica.",
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
		tippy('#prod-fv-span', {
			content: "Producción anual de la instalación fotovoltaica.",
			delay: [600, 100],
			animation: 'shift-away',
			inertia: true
		});
	}
	obtenerBodyUbicacion() {
		const pol = this.drawed_features;
		let feats = [];

		this.anchoPanel = $('#input-ancho').val();
		this.largoPanel = $('#input-longitud').val();
		const inclinacion = $('#input-grados').val();
		const orientacion = $('#input-grados-orient').val();

		if (this.anchoPanel == '')
			this.anchoPanel = 1;

		if (this.largoPanel == '')
			this.largoPanel = 2;

		if (inclinacion == '')
			inclinacion = 30;

		if (orientacion == '')
			orientacion = 0;

		const poligonoDibujo = this.drawed_features[0].center == undefined;
		if (poligonoDibujo) {
			for (let i = 0; i < pol.length; i++) {
				for (let j = 0; j < pol[i].geometry.coordinates.length; j++) {
					const coords = [pol[i].geometry.coordinates[j].map(x => ol.proj.transform(x, 'EPSG:3857', 'EPSG:4326'))];
					const feat_parsed = {
						"type": "Feature",
						"geometry": {
							"type": "Polygon",
							"coordinates": coords
						}
					};

					feats.push(feat_parsed);
				}
			}
		} else {
			for (let i = 0; i < pol.length; i++) {
				for (let j = 0; j < pol[i].geometry.coordinates.length; j++) {
					const coords = [pol[i].geometry.coordinates[j][0].map(x => ol.proj.transform(x, 'EPSG:3857', 'EPSG:4326'))];
					const feat_parsed = {
						"type": "Feature",
						"geometry": {
							"type": "Polygon",
							"coordinates": coords
						}
					};

					feats.push(feat_parsed);
				}
			}
		}

		return {
			"inputs": {
				"geojson": {
					"features": feats,
					"type": "FeatureCollection"
				},
				"altura_placa": Number(this.largoPanel),
				"anchura_placa": Number(this.anchoPanel),
				"inclinacion": Number(inclinacion),
				"pintar_placas": true,
				"orientacion": Number(orientacion),
			}
		};
	}
	ubicacionPaneles(body) {
		this.pygeoapiUbicacionOptima(body, (response) => {
			if (response.error) {
				//console.log(body);
				//console.log(response);
				collapseSidebar();
				M.dialog.info("No se ha podido calcular la ubicación de los paneles.");
			} else {
				this.pintarFeaturesOptimaMapa(response);
			}
		});
	}
	pintarFeaturesOptimaMapa(response) {
		const features = response.resultado.features;
		const capaOptima = [];
		if (features != null && features.length > 0) {
			for (let f = 0; f < features.length; f++) {
				const reprojFeat = this.reproject_feature(features[f]);
				capaOptima.push(reprojFeat);
			}

			this.loadVectorLayer(capaOptima, "optimal", 1050);
			this.aplicarEstilos(this.layers.vector_optimal.getImpl().getOL3Layer());
		}
	}
	async ubicacionOptima(body) {
		let maxRad = 0;
		set_loading(LOADING_CONTEXT_PAGE, true);
		for (let i = 0; i <= 180; i += 30) {
			body.inputs.orientacion = i;

			let response = await this.fetchPygeoapi(config.pygeoapi.url + '/localizacion_optima/execution', body).then(response => response.json());
			let radMedia = 0;

			if (!response.error && response.resultado.features.length > 0) {
				for (let f of response.resultado.features)
					radMedia += f.properties.irradiacion_d;

				radMedia /= response.resultado.features.length;
				if (radMedia > maxRad) {
					this.pintarFeaturesOptimaMapa(response);
					maxRad = radMedia;
				}
			} else {
				set_loading(LOADING_CONTEXT_PAGE, false);
				M.dialog.info("No se ha podido calcular la ubicación óptima.");
				//console.log(body);
				//console.log(response);
			}
		}
		set_loading(LOADING_CONTEXT_PAGE, false);
	}
	async fetchPygeoapi(url, body) {
		return await fetch(url, {
			method: 'POST',
			body: JSON.stringify(body)
		});
	}
	aplicarConfiguracion() {

		this.perdidasGenerales = $('#input-perdidas').val();
		this.eficiencia = Number($('#input-eficiencia').val());

		const perdidas = (1 - this.perdidasGenerales / 100) * (1 - this.perdidaTemp / 100) * this.eficiencia / 100;

		this.produccionSolarFiltrado = parseInt(visor2D.filtered_table_data.valor_medio) * perdidas * visor2D.filtered_table_data.superficie;
		this.produccionSolarTotal = parseInt(visor2D.current_table_data.valor_medio) * perdidas * visor2D.current_table_data.superficie;

		document.getElementById('prod-fv-filt').innerHTML = `${Utils.numberWithCommas(this.produccionSolarFiltrado)} kW`;
		document.getElementById('prod-fv-total').innerHTML = `${Utils.numberWithCommas(this.produccionSolarTotal)} kW`;
	}
	aplicarEstilos(layer) {
		const cnv = document.createElement('canvas');
		const ctx = cnv.getContext('2d');

		const img = new Image();
		img.src = './pattern.jpg';

		img.onload = () => {
			const pattern = ctx.createPattern(img, 'repeat');

			layer.getSource().forEachFeature((f) => {
				const estilo = new ol.style.Style({
					fill: new ol.style.Fill({
						color: pattern
					}),
					stroke: new ol.style.Stroke({
						color: '#000000',
						width: 2
					})
				});
				f.setStyle(estilo);
			});
		}
	}
	abrirGrafico(puntos) {
		if (Chart.getChart('myChart'))
			Chart.getChart('myChart').destroy();

		if (puntos.length !== 0) {
			document.getElementById('rad-chart').innerHTML = '<canvas id="myChart" class="chart-class"></canvas>';
			let radiacion = new Array(12).fill(0);

			for (let i = 0; i < puntos.length; i++) {
				for (let j = 0; j < 12; j++) {
					const diasEnMes = new Date(2024, j, 0).getDate()
					const rad = diasEnMes * puntos[i].properties[`value_mes_${j + 1}`] / 1000;
					radiacion[j] += rad;

					if (rad > this.maximoRadiacion)
						this.maximoRadiacion = rad;
				}
			}

			const valoresRad = radiacion.map(x => parseInt(x / puntos.length));
			const valoresRadMedia = new Array(12).fill(parseInt(radiacion.reduce((a, b) => a + b, 0) / (puntos.length * 12)));
			const maximo = parseInt(Math.round(this.maximoRadiacion / 100) * 100) + 50;

			new Chart(document.getElementById('myChart'), {
				type: 'line',
				data: {
					labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
					datasets: [{
						label: 'Radiación solar ',
						data: valoresRad,
						borderWidth: 1,
						borderColor: '#ff0000',
						color: '#5900ff',
						backgroundColor: '#ffffff',
					}, {
						label: 'Radiación solar media',
						data: valoresRadMedia,
						borderWidth: 1,
						borderColor: '#5900ff',
						color: '#5900ff',
						backgroundColor: '#ffffff',
						pointRadius: 0,
					}]
				},
				options: {
					animation: {
						duration: 0
					},
					plugins: {
						legend: {
							labels: {
								boxHeight: 0,
								color: '#000000',
								font: {
									family: 'Quicksand'
								}
							}
						}
					},
					scales: {
						y: {
							title: {
								display: true,
								text: 'Radiación solar (kWh/m²)',
								font: {
									family: 'Quicksand'
								}
							},
							beginAtZero: true,
							max: maximo,
							ticks: {
								color: '#000000',
								font: {
									family: 'Quicksand'
								}
							},
							border: {
								color: '#000000',
							},
							grid: {
								display: false
							}
						},
						x: {
							ticks: {
								color: '#000000',
								font: {
									family: 'Quicksand'
								}
							},
							border: {
								color: '#000000',
							},
							grid: {
								display: false
							},
						}
					}
				}
			});
		} else {
			document.getElementById('rad-chart').innerHTML = 'No hay datos.';
		}
	}
	get_community_features(center) {

		let coordinates_feature_big = ol.geom.Polygon.circular(center, visor2D.community_radius);
		coordinates_feature_big = coordinates_feature_big.transform("EPSG:4326", "EPSG:3857");
		coordinates_feature_big = coordinates_feature_big.getCoordinates()[0];
		const feature_big = {
			"geometry": {
				"type": "Polygon",
				"coordinates": [
					coordinates_feature_big
				]
			},
			"type": "Feature",
			"properties": {
				"type": "radius",
				"size": "big",
			}
		};
		
		return [feature_big]

	}

	updateDefaultsWithURL() {

		var url_string = window.location.href;
		var url = new URL(url_string);

		$("#close-optima").click(() => {
			if (!$("#ubicacion-optima").hasClass("d-none"))
				$("#ubicacion-optima").addClass("d-none");
		});

		$("#btn-ubicacion-opt").click(() => {
			if ($("#ubicacion-optima").hasClass("d-none"))
				$("#ubicacion-optima").removeClass("d-none");
		});

		if (this.default.base == "IGNBaseTodo.tms") {
			document.getElementById("IGNBaseTodo-tms").checked = true;
			document.getElementById("pnoa-tms").checked = false;
		} else {
			document.getElementById("IGNBaseTodo-tms").checked = false;
			document.getElementById("pnoa-tms").checked = true;
		}
		if (this.default.radiacion == "radiacion_solar_media") {
			document.getElementById("Edificios").checked = false;
			document.getElementById("building_h30_3042_index").checked = true;
			document.getElementById("solar_media_publico").checked = false;
			document.getElementById("radiacion_solar_global").checked = false;
		} else if (this.default.radiacion == "radiacion_solar_media_publico") {
			document.getElementById("Edificios").checked = false;
			document.getElementById("building_h30_3042_index").checked = false;
			document.getElementById("solar_media_publico").checked = true;
			document.getElementById("radiacion_solar_global").checked = false;
		} else if (this.default.radiacion == "no") {
			document.getElementById("Edificios").checked = false;
			document.getElementById("building_h30_3042_index").checked = false;
			document.getElementById("solar_media_publico").checked = false;
			document.getElementById("radiacion_solar_global").checked = false;
		} else if (this.default.radiacion == "radiacion_solar_global") {
			document.getElementById("Edificios").checked = false;
			document.getElementById("building_h30_3042_index").checked = false;
			document.getElementById("solar_media_publico").checked = false;
			document.getElementById("radiacion_solar_global").checked = true;
		}
		$("#btn-ubicacion-calc").click(() => {
			$("#ubicacion-optima").addClass("d-none");
			this.ubicacionOptima();
		});
	}
	set_M_config() {
		M.config.PROXY_URL = "https://componentes.cnig.es/api-core/api/proxy";
		M.config.PROXY_POST_URL = "https://componentes.cnig.es/api-core/proxyPost";
		M.config.THEME_URL = "https://componentes.cnig.es/api-core/assets/";
	}
	instantiate_map() {

		this.layers.ignbasetodo = new M.layer.TMS({
			url: 'https://tms-ign-base.idee.es/1.0.0/IGNBaseTodo/{z}/{x}/{-y}.jpeg',
			name: 'IGNBaseTodo.tms',
			projection: 'EPSG:3857',
			tileGridMaxZoom: 17, // especifica el nivel máximo creado en el servicio para permitir hacer "overzoom"																							  
			visibility: true,
		});

		this.layers.ignbasetodoWMTS = new M.layer.WMTS(
			{
				url: "https://www.ign.es/wmts/ign-base",
				matrixSet: 'GoogleMapsCompatible',
				layer: "IGNBaseTodo",
				name: "IGNBaseTodo",
				legend: "IGNBaseTodo",
				maxZoom: 22,
				visibility: false,
			},
			{
				format: 'image/jpeg'
			}
		);

		return M.map({
			container: "map",
			projection: "EPSG:3857*m",
			controls: ["scaleline"],
			zoom: this.default.z,
			center: [this.default.x, this.default.y],
			maxZoom: 21,
			layers: [
				this.layers.ignbasetodo,
				this.layers.ignbasetodoWMTS
			],
		});

	}
	addLayersToMap() {


		this.layers.ignbasetodo = this.map.getLayers().filter(e => e.name == "IGNBaseTodo.tms")[0]

		this.map.addLayers(this.layers.orthofoto);
		this.map.addLayers(this.layers.catastro); // TODO
		this.layers.catastro.setZIndex(9999);

		this.map.addLayers([this.layers.raster]);
		this.map.addLayers(this.layers.global_radiation);

		this.map.addLayers(this.layers.solar_media);
		this.map.addLayers(this.layers.solar_media_publico);
		this.layers.solar_media.setOpacity(opacitySlider.value);
		this.layers.solar_media_publico.setOpacity(opacitySlider.value);
		this.layers.global_radiation.setOpacity(opacitySlider.value);

		if (window.location.href.indexOf('catastro') !== -1) {
			document.getElementById('Catastro').checked = true;
			this.layers.catastro.setVisible(true);
			this.layers.raster.setOpacity(1)
		} else {
			this.layers.catastro.setVisible(false);
		}

		this.initialSwitchMapLayers();
	}
	opacityLayers(opacity) {
		this.layers.solar_media.setOpacity(opacity);
		this.layers.solar_media_publico.setOpacity(opacity);
		this.layers.global_radiation.setOpacity(opacity);
		this.layers.raster.setOpacity(opacity)
	}
	addControlsToMap() {

		const locator = new M.plugin.Locator({
			position: 'TL',
			collapsible: false,
			// useProxy:false,
			zoom: 20,
			ignsearchlocator: 'entityFound',
			byParcelCadastre: false,
			byCoordinates: false,
			byPlaceAddressPostal: {
				servicesToSearch: 'g',
				maxResults: 15,
				noProcess: '',
				reverse: false,
			},
			isDraggable: false,
		});

		this.locator = locator
		this.map.addPlugin(locator);

	}
	initialSwitchMapLayers() {

		if (this.default.base == "IGNBaseTodo.tms") {
			this.layers.orthofoto.setVisible(false);
			this.layers.ignbasetodo.setVisible(true);
		} else {
			this.layers.orthofoto.setVisible(true);
			this.layers.ignbasetodo.setVisible(false);
		}

		if (this.default.radiacion == "radiacion_solar_media_publico") {
			this.layers.raster.setVisible(false);
			this.layers.solar_media.setVisible(false);
			this.layers.solar_media_publico.setVisible(true);
			this.layers.global_radiation.setVisible(false);
		} else if (this.default.radiacion == "radiacion_solar_media") {
			this.layers.raster.setVisible(false);
			this.layers.solar_media.setVisible(true);
			this.layers.solar_media_publico.setVisible(false);
			this.layers.global_radiation.setVisible(false);
		} else if (this.default.radiacion == "radiacion_solar") {
			this.layers.raster.setVisible(true);
			this.layers.solar_media.setVisible(false);
			this.layers.solar_media_publico.setVisible(false);
			this.layers.global_radiation.setVisible(false);
		} else if (this.default.radiacion == "radiacion_solar_global") {
			this.layers.raster.setVisible(false);
			this.layers.solar_media.setVisible(false);
			this.layers.solar_media_publico.setVisible(false);
			this.layers.global_radiation.setVisible(true);
		} else {
			this.layers.raster.setVisible(false);
			this.layers.solar_media.setVisible(false);
			this.layers.solar_media_publico.setVisible(false);
			this.layers.global_radiation.setVisible(false);
		}

	}
	handle_apicnig_events() {
		this.map.on(M.evt.CHANGE_ZOOM, (m) => {
			visor2D.zoomChanged(m.getZoom());
		});
		this.map.on(
			M.evt.CLICK,
			(features) => {

				// return
				const coordinates = ol.proj.transform(
					features.coord,
					'EPSG:3857',
					'EPSG:4326',
				);
				const point_feature = {
					"geometry": {
						"coordinates": coordinates,
						"type": "Point"
					},
					"properties": {},
					"type": "Feature"
				};

				if (selection_plugin.is_building_mode() && $('#building-plus').hasClass('activated') || $('#building-less').hasClass('activated')) {
					const body = {
						"inputs": {
							"entidad": "edificio",
							"geojson": {
								"features": [
									point_feature
								],
								"type": "FeatureCollection",
							},
							"limite": 3
						}
					};

					if (selection_plugin.current_toggle_mode === selection_plugin.SELECTION_MODE_SUBSTRACT && ($('#dot-plus').hasClass('activated') || $('#dot-less').hasClass('activated'))) {
						// Create the polygon feature dictionary
						const [longitude, latitude] = features.coord;
						const polygonFeature = {
							type: 'Feature',
							properties: {},
							geometry: {
								type: 'Point',
								coordinates: [longitude, latitude]
							}
						};

						visor2D.substract_buildings(polygonFeature);

						if (visor2D.current_rendering_mode === visor2D.RENDERING_BUILDINGS) {

							return;

						}
					}

					//visor2D.fetchBuilding(body, point_feature);
					visor2D.getBuildingID(features.coord[0], features.coord[1]);
				}

				if (selection_plugin.is_point_mode() && ($('#dot-plus').hasClass('activated') || $('#dot-less').hasClass('activated'))) {
					const ccoordinates = Utils.geometry.getCircle(coordinates, 1);
					const polygon_feature = {
						type: 'Feature',
						properties: {},
						geometry: {
							type: 'Polygon',
							coordinates: [ccoordinates]
						}
					};

					if (selection_plugin.current_toggle_mode === selection_plugin.SELECTION_MODE_SUBSTRACT) {

						// const projected_feature = visor2D.reproject_feature(point_feature);
						const substract_feature = {
							"geometry": {
								"coordinates": features.coord,
								"type": "Point"
							},
							"properties": {},
							"type": "Feature"
						};

						// Delete clicked feature
						//visor2D.layers.vector_points.on(M.evt.SELECT_FEATURES, (features) => { 
						//	console.log("Se han seleccionado los objetos geográficos: ", features); 
						//	
						//});

						//visor2D.substract_points(substract_feature);

					} else {

						visor2D.searchByPolygon(polygon_feature, false);

					}
				}
			}, this
		);

		visor2D.mp.on('finished:draw', (feature) => {

			if (feature.geometry.type === 'Point') {

				// $("#comunidad-energetica-collapse").removeClass("d-none");
				const center = feature.geometry.coordinates;
				const circle = this.get_community_features(center);
				visor2D.loadVectorLayer(circle, "community", 1036);

			} else if (feature.geometry.type === 'Polygon') {

				if (selection_plugin.current_toggle_mode === selection_plugin.SELECTION_MODE_ADD) {

					visor2D.searchByPolygon(feature, true);

				} else if (selection_plugin.current_toggle_mode === selection_plugin.SELECTION_MODE_SUBSTRACT) {

					const projected_feature = visor2D.reproject_feature(feature);
					visor2D.substract_points(projected_feature);
					visor2D.substract_buildings(projected_feature);

					visor2D.substract_feature = projected_feature;
					visor2D.render_drawed_polygons();

				}


			}

			// clear plugin geometries
			setTimeout(() => {
				visor2D.map.getLayers().find(l => l.name === '__draw__').clear();
			}, 100);

		});
	}
	fetchBuilding(body, point_feature, zoom) {
		// make a request to pygeoapi to get buildings
		// point_feature will render a dot as weel

		visor2D.pygeoapi(body, (response) => {
			if (response.error) {
				//console.log(response.error);
				collapseSidebar();
				M.dialog.info("No hay información en el punto seleccionado");
				return;
			}


			const features = response.resultado.features;
			const building = features[0];
			const projected_building = visor2D.reproject_feature(building);


			if (point_feature) {
				if (visor2D.current_rendering_mode === visor2D.RENDERING_POINTS) {
					visor2D.drawed_features_points.push(point_feature);
				}
			}

			// substract instead of add
			if (selection_plugin.current_toggle_mode === selection_plugin.SELECTION_MODE_SUBSTRACT) {
				visor2D.substract_points(projected_building);
				visor2D.substract_feature = projected_building;
				visor2D.render_drawed_polygons();
				return;
			} else {
				visor2D.drawed_features.push(projected_building);
				visor2D.render_drawed_polygons();

			}

			const referencia_catastral = features[0].properties.id_parcela;
			visor2D.print_points_with_referencia(referencia_catastral, true, zoom);

		});
	}
	substract_points(feature) {
		// substract points of the map according to a polygon
		let new_points_list = [];
		for (let dot of visor2D.points_features) {

			if (!turf.booleanIntersects(feature, dot) || dot.properties.wms) {
				new_points_list.push(dot);
			}
		}
		visor2D.points_features = new_points_list;
		// update points and buildings
		visor2D.add_points();
		visor2D.add_buildings();
	}
	substract_buildings(feature, percentaje) {
		let new_buildings_list = [];
		for (let dot of visor2D.buildings_features) {


			if (percentaje) {

				var intersection = turf.intersect(feature, dot);
				if (intersection) {
					var feature_area = turf.area(feature);

					// Calculate the area of the intersection
					var intersectionArea = turf.area(intersection);

					// Calculate the percentage of intersection
					var intersectionPercentage = (intersectionArea / feature_area) * 100;

					// Check if the percentage of intersection is greater than 50%
					if (intersectionPercentage < percentaje) {
						new_buildings_list.push(dot);
					}
				} else {
					new_buildings_list.push(dot);
				}

			} else {
				if (!turf.booleanIntersects(feature, dot)) {
					new_buildings_list.push(dot);
				}
			}

		}
		visor2D.buildings_features = new_buildings_list;
		// update
		visor2D.add_buildings();
		visor2D.add_points();
	}
	addLayerInputsEvents() {
		this.inputs.layers.catastro.click(function () {
			this.changeVisibility('Catastro', null);
			updateURL();
		}.bind(this))
		this.inputs.layers.radiacion_solar.on('change', function (e) {
			this.changeRadiationLayer(e, this.layers.raster, "radiacion_solar");
		}.bind(this));
		this.inputs.layers.radiacion_solar_media.on('change', function (e) {
			this.changeRadiationLayer(e, this.layers.solar_media, "radiacion_solar_media");
		}.bind(this));
		this.inputs.layers.radiacion_solar_media_publico.on('change', function (e) {
			this.changeRadiationLayer(e, this.layers.solar_media_publico, "radiacion_solar_media_publico");
		}.bind(this));
		this.inputs.layers.radiacion_solar_global.on('change', function (e) {
			this.changeRadiationLayer(e, this.layers.global_radiation, "radiacion_solar_global");
		}.bind(this));
		this.inputs.layers.ortofoto.click(function () {
			visor3D.set_orthofoto();
			this.changeBaseLayer('pnoa.tms');
		}.bind(this))
		this.inputs.layers.baseign.click(function () {
			visor3D.set_ignbasetodo();
			this.changeBaseLayer('IGNBaseTodo.tms');
		}.bind(this));
	}
	getBuildingID(x, y) {
		visor2D.map.getLayers().find(l => l.name === '__draw__').clear();
		this.map.removeLayers(this.layers.radiacion_solar_puntos);
		this.map.removePopup();

		const olMap = this.map.getMapImpl();
		const viewResolution = olMap.getView().getResolution();
		const srs = this.map.getProjection().code;
		const informationParams = {
			INFO_FORMAT: "application/json",
			FEATURE_COUNT: 10,
		};
		const coord = [x, y];

		const olLayer = this.layers.solar_media.getImpl().getOL3Layer();

		const source = olLayer.getSource();
		const url = source.getFeatureInfoUrl(
			coord,
			viewResolution,
			srs,
			informationParams
		);

		set_loading(LOADING_CONTEXT_PAGE, true);

		M.remote.get(url).then(
			(data) => {

				let response = JSON.parse(data.text);

				if (response.features.length > 0) {

					let feature = response.features[0];
					let referencia_catastral = feature.properties.reference;
					if (referencia_catastral != null && referencia_catastral != undefined) {
						const buildingId = feature["id"].split(".")[1];
						//window.buildingId = buildingId;

						if (selection_plugin.current_toggle_mode === selection_plugin.SELECTION_MODE_SUBSTRACT) {
							const indIDRemove = this.buildingsID.indexOf(buildingId);
							if (indIDRemove > -1)
								this.buildingsID.splice(indIDRemove, 1);
							visor2D.points_features = visor2D.points_features.filter(e => e.properties.id_parcela !== referencia_catastral);

						} else {
							this.buildingsID.push(buildingId);
						}

						if (buildingId != null && buildingId != undefined && buildingId.length > 0)
							visor2D.print_points_with_referencia(referencia_catastral, false);

					} else {
						//visor2D.print_points_with_referencia(referencia_catastral);
						//collapseSidebar();
						//set_loading(LOADING_CONTEXT_PAGE, false);
						//M.dialog.info("No hay información en el punto seleccionado");

					}
				} else {
					//set_loading(LOADING_CONTEXT_PAGE, false);
					//M.dialog.info("No hay información en el punto seleccionado");
				}

				set_loading(LOADING_CONTEXT_PAGE, false);
			},
			(response) => {
				//console.log("fail", response);
			}
		).catch(
			(response) => {
				//console.log("fail", response);
			}
		);
	}
	transform_coordinates(coordinates) {
		let building_geometry = [];
		for (const feature of coordinates) {
			let current_coordinates = [];
			for (const coordinate of feature) {
				const proj_coordinate = ol.proj.transform(
					coordinate,
					'EPSG:4326',
					'EPSG:3857'
				);
				current_coordinates.push(proj_coordinate);
			}
			building_geometry.push(current_coordinates);
		}
		return building_geometry;
	}
	get_building_feature(building_coordinates) {
		building_coordinates = visor2D.transform_coordinates(building_coordinates)
		building_geometry = {
			"geometry": {
				"type": "MultiPolygon",
				"coordinates": [
					building_geometry
				]
			},
			"properties": {
				"type": "building"
			}
		};
		return building_geometry;
	}
	startInterpolation(lat, lng) {

		const impl = visor2D.map.getImpl().getMapImpl();
		const view = impl.getView();

		view.animate({
			center: [lng, lat],
			zoom: 18,
			duration: 100,
		});

	}


	changeBaseLayer(layerName) {

		if (this.map.getZoom() > 17) {
			if (layerName == "IGNBaseTodo.tms") {
				this.layers.ignbasetodoWMTS.setVisible(true)
			} else {
				visor2D.layers.ignbasetodoWMTS.setVisible(false);
				if (window.PnoaMessage) {
					M.dialog.info("Tenga en cuenta que la imagen puede tener deformaciones debido a la altura del edificio");
					window.PnoaMessage = false;
				}
			}
		}

		this.changeVisibility(layerName, true);
		this.changeVisibility(this.contrarios[layerName], false);

		this.default.base = layerName;
		updateURL();

	}
	changeVisibility(layer_name, visibility) {

		this.map.getLayers().forEach((layer) => {
			if (layer.name == layer_name.replace("-", ".")) {
				if (visibility === null) {
					layer.setVisible(!layer.isVisible());
				} else {
					layer.setVisible(visibility);
				}
			}
		});

	}
	changeRadiationLayer(e, layer, defaultRadiacion) {
		const checkbox = e.currentTarget;
		const isChecked = checkbox.checked;

		layer.setVisible(isChecked);

		if (isChecked) {

			visor2D.default.radiacion = defaultRadiacion;

			const checkbox_parentes = $(checkbox).parent().parent().children();
			for (const checkbox_parent of checkbox_parentes) {
				const current_checkbox = $(checkbox_parent).children()[0];
				if (checkbox === current_checkbox) continue;
				if (!current_checkbox.checked) continue;
				current_checkbox.click();
			}


		} else {
			const checkboxs = [...$(checkbox).parent().parent().children()];
			const anyChecked = checkboxs.map(i => $(i).children()[0].checked);
			if (!anyChecked.some(i => i)) {
				visor2D.default.radiacion = "no";
			}
		}

		updateURL();
	}
	print_points_with_referencia(referencia_catastral, zoom) {

		let body = {
			'inputs': {
				'entidad': 'puntos',
				'limite': 50000,
				"percentil": 100,
				'referencia_catastral': [referencia_catastral]
			}
		};
		if (visor2D.current_rendering_mode === visor2D.RENDERING_BUILDINGS) {
			body.inputs.entidad = 'edificios';
		}

		// get points from ReferenciaCatastral
		visor2D.pygeoapi(
			body,
			(response) => {

				if (response.error) {
					//console.log(response.error);
					return;
				}

				//console.log("response.resultado.features", response.resultado.features.length);

				this.pointsCounter += response.resultado.features.length;
				if (response.resultado.features.length > 0) { // WMS 

					visor2D.layers.radiacion_solar_puntos = new M.layer.WMS(
						{
							name: config.geoserver.wms.radiacion_solar_puntos.name,
							url: config.geoserver.wms.radiacion_solar_puntos.url,
							transparent: config.geoserver.wms.radiacion_solar_puntos.transparent,
							tiled: config.geoserver.wms.radiacion_solar_puntos.tiled,
							version: config.geoserver.wms.radiacion_solar_puntos.version,
						},
						{
							//params: { CQL_FILTER: "id_edificio=" + window.buildingId },
							params: { CQL_FILTER: "value_anual >" + filterSlider.watios + " AND id_edificio IN (" + this.buildingsID.join(", ") + ")" }
						}
					);
					visor2D.map.addLayers(visor2D.layers.radiacion_solar_puntos);
					visor2D.layers.radiacion_solar_puntos.setOpacity(1);
					visor2D.layers.radiacion_solar_puntos.setZIndex(1038);
					visor2D.add_points(response, false);

				} else {
					// load points
					if (body.inputs.entidad === 'edificios') {
						visor2D.add_buildings(response, visor2D.REPROJECT);
					} else if (body.inputs.entidad === 'puntos') {
						//visor2D.add_points(response, true);
						visor2D.add_points(response, false);
					}
				}

				uncollapseSidebar();
				visor2D.additional_feature = undefined;

				if (zoom && response.resultado.features != null && response.resultado.features.length > 0) {
					const center = response.resultado.features[0].geometry.coordinates
					visor2D.map.setCenter({ x: center[0], y: center[1] });
					visor2D.map.setZoom(17);
				}

				// not loading
				set_loading(LOADING_CONTEXT_SEARCH, false);

			}
		);

	}

	getBuildingDots() {

		let valor_ = filterSlider.watios;

		// if (layer_) {
		let olLayer = visor2D.layers.radiacion_solar_puntos.getImpl().getOL3Layer();
		let source = olLayer.getSource();
		//console.log(valor_);
		source.updateParams({
			//cql_filter: "VALUE >" + valor_ + " AND id_edificio=" + window.buildingId,
			cql_filter: "value_anual >" + valor_ + "AND id_edificio IN (" + this.buildingsID.join(", ") + ")"
		});
		// }
	}

	parseTableValue(val) {

		// round
		val = Math.round(
			parseFloat(val)
		);

		// switch . for ,
		val = val.toLocaleString("en-US").replaceAll(".", "-").replaceAll(",", ".").replaceAll("-", ",");

		// add 3 trailing zeros
		let val_decimals = val.split(",")[1];
		if (val_decimals) {
			if (val_decimals !== 3) {
				val = val.split(",")[0];
				val_decimals = val_decimals.pad(3);
				val += "," + val_decimals;
			}
		}

		return val;
	}
	parse_features(feature) {

		if (feature.superficie === 0) {
			return {
				surface: 0,
				valor_medio: 0,
				valor_minimo: 0,
				valor_maximo: 0,
				valor_acumulado: 0,
				coste: 0
			}
		}

		let surface = feature.superficie;

		let valor_medio = Math.round(feature.valor_medio);
		let valor_minimo = this.parseTableValue(
			Math.round(feature.valor_minimo)
		);
		let valor_maximo = this.parseTableValue(
			Math.round(feature.valor_maximo)
		);
		// let valor_acumulado = Math.round(feature.valor_total / 1000);
		let valor_acumulado = Utils.numberWithCommas(Math.round((Math.round(parseFloat(valor_medio)) / 1000) * surface));
		let coste = this.calcularCosteInstalacion(surface);

		// valor_acumulado = numberWithCommas(valor_acumulado);
		surface = Utils.numberWithCommas(surface);
		valor_medio = this.parseTableValue(valor_medio);

		return {
			surface, valor_medio, valor_minimo, valor_maximo, valor_acumulado, coste
		};
	}
	getTableHTML(feature_total, feature_filtered) {

		this.filtered_table_data = feature_filtered;
		const data_total = visor2D.parse_features(feature_total)
		const data_filtered = visor2D.parse_features(feature_filtered)

		let surface_percentaje = 0;
		let valor_medio_percentaje = 0;
		let valor_minimo_percentaje = 0;
		let valor_maximo_percentaje = 0;
		let valor_acomulado_percentaje = 0;
		let price_percentaje = 0;

		if (feature_total.superficie) {

			this.produccionSolarFiltrado = parseInt(data_filtered.valor_medio.replace('.', '')) * (this.eficiencia / 100) * (1 - this.perdidaTemp / 100) * (1 - this.perdidasGenerales / 100) * feature_filtered.superficie;
			this.produccionSolarTotal = parseInt(data_total.valor_medio.replace('.', '')) * (this.eficiencia / 100) * (1 - this.perdidaTemp / 100) * (1 - this.perdidasGenerales / 100) * feature_total.superficie;

			// Botón simulación
			if ($("#btn-simulacion").hasClass("d-none"))
				$("#btn-simulacion").removeClass("d-none");

			// Botón configuración
			if ($("#btn-config").hasClass("d-none"))
				$("#btn-config").removeClass("d-none");

			// Botones optimización
			if ($("#btn-consumo-opt").hasClass("d-none"))
				$("#btn-consumo-opt").removeClass("d-none");

			if ($("#btn-amort-opt").hasClass("d-none"))
				$("#btn-amort-opt").removeClass("d-none");

			if ($("#tip-autoconsumo").hasClass("d-none"))
				$("#tip-autoconsumo").removeClass("d-none");

			if ($("#tip-amort").hasClass("d-none"))
				$("#tip-amort").removeClass("d-none");

			surface_percentaje = (feature_filtered.superficie / feature_total.superficie) * 100;
			valor_medio_percentaje = (feature_filtered.valor_medio / feature_total.valor_medio) * 100;
			valor_minimo_percentaje = (feature_filtered.valor_minimo / feature_total.valor_minimo) * 100;
			valor_maximo_percentaje = (feature_filtered.valor_maximo / feature_total.valor_maximo) * 100;

			// calc valor_acumulado
			const [valor_acumulado_total, valor_acumulado_filtered] = [Math.round((Math.round(feature_total.valor_medio) / 1000) * feature_total.superficie), Math.round((Math.round(feature_filtered.valor_medio) / 1000) * feature_filtered.superficie)]
			valor_acomulado_percentaje = (valor_acumulado_filtered / valor_acumulado_total) * 100;

			// calc price
			const [price_total, price_filtered] = [this.calcularCosteInstalacion(feature_total.superficie), this.calcularCosteInstalacion(feature_filtered.superficie)]
			price_percentaje = (price_filtered / price_total) * 100;
			this.filtered_table_data.price = price_filtered;
		}

		surface_percentaje = Math.round(surface_percentaje * 10) / 10;
		valor_medio_percentaje = Math.round(valor_medio_percentaje * 10) / 10;
		valor_minimo_percentaje = Math.round(valor_minimo_percentaje * 10) / 10;
		valor_maximo_percentaje = Math.round(valor_maximo_percentaje * 10) / 10;
		valor_acomulado_percentaje = Math.round(valor_acomulado_percentaje * 10) / 10;
		//price_percentaje = Math.round(price_percentaje * 10) / 10;

		const porcentajePotencia = parseInt((feature_filtered.superficie * (this.eficiencia / 100)) / (feature_total.superficie * (this.eficiencia / 100)) * 100);

		let html = `
			<table id="radiation-table" class="table styled-table">

				<thead>
					<tr>
						<th> Variable </th>
						<th> Filtrado </th>
						<th> Total </th>
					</tr>
				</thead>

				<tbody>
					<tr>
						<td>
							<span id="superficie" class="tooltip-button">Superficie<i class="bi bi-info-circle-fill"></i> </span>
						</td>
						<td>${data_filtered.surface} m&#178 (${surface_percentaje}%) </td>
						<td>${data_total.surface} m&#178</td>
					</tr>
					<tr>
						<td class="position-relative">
							<div class="tooltip-button noselect">
								<span id="valor-medio-anual">Valor medio anual<i class="bi bi-info-circle-fill"></i> </span>
							</div>
						</td>
						<td id="rad-val-medio">${data_filtered.valor_medio} kWh/m&#178</td>
						<td>${data_total.valor_medio} kWh/m&#178 </td>
					</tr>
					<tr>
						<td class="position-relative">
							<div class="tooltip-button noselect">
								<span id="valor-minimo-anual">Valor mínimo anual <i class="bi bi-info-circle-fill"></i> </span>
							</div>
						</td>
						<td id="rad-val-min">${data_filtered.valor_minimo} kWh/m&#178</td>
						<td>${data_total.valor_minimo} kWh/m&#178</td>
					</tr>
					<tr>
						<td class="position-relative">
							<div class="tooltip-button noselect">
								<span id="valor-maximo-anual">Valor máximo anual <i class="bi bi-info-circle-fill"></i> </span>
							</div>
						</td>
						<td id="rad-val-max">${data_filtered.valor_maximo} kWh/m&#178</td>
						<td>${data_total.valor_maximo} kWh/m&#178</td>
					</tr>
					<tr>
						<td class="position-relative">
							<div class="tooltip-button noselect">
								<span id="energia-solar-acumulada">Energía solar acumulada <i class="bi bi-info-circle-fill"></i> </span>
							</div>
						</td>
						<td id="rad-val-ac">${data_filtered.valor_acumulado} MWh (${valor_acomulado_percentaje}%)</td>
						<td>${data_total.valor_acumulado} MWh</td>
					</tr>
					<tr>
						<td class="position-relative">
							<div class="tooltip-button noselect">
								<span id="prod-fv-span">Producción fotovoltaica anual<i class="bi bi-info-circle-fill"></i> </span>
							</div>
						</td>
						<td id="prod-fv-filt">${Utils.numberWithCommas(this.produccionSolarFiltrado)} kWh</td>
						<td id="prod-fv-total">${Utils.numberWithCommas(this.produccionSolarTotal)} kWh</td>
					</tr>
					<tr>
						<td class="position-relative">
							<div class="tooltip-button noselect">
								<span id="potencia-pico">Potencia máxima<i class="bi bi-info-circle-fill"></i> </span>
							</div>
						</td>
						<td id="pot-max">${Utils.numberWithCommas(feature_filtered.superficie * (this.eficiencia / 100))} kW (${porcentajePotencia}%)</td>
						<td>${Utils.numberWithCommas(feature_total.superficie * (this.eficiencia / 100))} kW</td>
					</tr>
				</tbody>
			</table>
			`;

		return html;
	}
	optimizar(parametro) {
		filterSlider.sliderMove({ currentTarget: { value: 0 } });
		let porcentajeParadaAutoconsumo = 0;
		let porcentajeParadaAmortizacion = 0;

		let porcentajeParadaAutoconsumoSinDatos = 0;
		let porcentajeParadaAmortizacionSinDatos = 0;

		let amortizacionAnt = Number.MAX_VALUE;
		let ahorroAnt = Number.MAX_VALUE;
		for (let i = 100; i >= 0; i--) {
			filterSlider.sliderMove({ currentTarget: { value: i } });

			if (Math.abs(this.ahorroCompensacion) < ahorroAnt) {
				porcentajeParadaAutoconsumo = i;
				ahorroAnt = Math.abs(this.ahorroCompensacion);
			}

			if (this.amortizacion < amortizacionAnt) {
				amortizacionAnt = this.amortizacion;
				porcentajeParadaAmortizacion = i;
			}

			if ((this.ahorroCompensacion == '' || this.amortizacion == '') && porcentajeParadaAutoconsumoSinDatos < i - 1 && porcentajeParadaAmortizacionSinDatos < i - 1) {
				porcentajeParadaAutoconsumoSinDatos = i - 1;
				porcentajeParadaAmortizacionSinDatos = i - 1;
			}

		}

		// Autoconsumo
		if (parametro == 1) {
			filterSlider.sliderMove({ currentTarget: { value: porcentajeParadaAutoconsumo } });

			if (this.ahorroCompensacion == '' || this.amortizacion == '') {
				filterSlider.sliderMove({ currentTarget: { value: porcentajeParadaAutoconsumoSinDatos } });
			}
		}

		// Amortización
		else {
			filterSlider.sliderMove({ currentTarget: { value: porcentajeParadaAmortizacion } });

			if (this.ahorroCompensacion == '' || this.amortizacion == '') {
				filterSlider.sliderMove({ currentTarget: { value: porcentajeParadaAmortizacionSinDatos } });
			}
		}
	}
	getTableEconomicsHTML(featureTotal, featureFiltered) {
		const consumoP1 = $("#input-consumo-p1").val().replace(',', '.') == '' ? this.consumoP1Default : parseFloat($("#input-consumo-p1").val().replace(',', '.'));
		const consumoP2 = $("#input-consumo-p2").val().replace(',', '.') == '' ? this.consumoP2Default : parseFloat($("#input-consumo-p2").val().replace(',', '.'));
		const consumoP3 = $("#input-consumo-p3").val().replace(',', '.') == '' ? this.consumoP3Default : parseFloat($("#input-consumo-p3").val().replace(',', '.'));

		const precioP1 = $("#input-precio-p1").val().replace(',', '.') == '' ? this.precioP1Default : parseFloat($("#input-precio-p1").val().replace(',', '.'));
		const precioP2 = $("#input-precio-p2").val().replace(',', '.') == '' ? this.precioP1Default : parseFloat($("#input-precio-p2").val().replace(',', '.'));
		const precioP3 = $("#input-precio-p3").val().replace(',', '.') == '' ? this.precioP1Default : parseFloat($("#input-precio-p3").val().replace(',', '.'));

		const precioComp = $("#input-compensacion").val().replace(',', '.') == '' ? this.precioCompensacionDefault : parseFloat($("#input-compensacion").val().replace(',', '.'));

		/*
			if energProd < consumo
				consumoEutos = energProd * precioKw
				compEuros = 0
			else
				consumoEutos = consumo * precioKw
				compEnerg = consumo - energProd
				compEuros = compensacionEnergia * precioComp
		*/

		const consumo = 12 * (consumoP1 + consumoP2 + consumoP3);
		const energiaProducidaFiltrada = Math.round(featureFiltered.valor_medio) * Math.round(featureFiltered.superficie) * (this.eficiencia / 100) * (1 - this.perdidaTemp / 100) * (1 - this.perdidasGenerales / 100);
		const energiaProducidaTotal = Math.round(featureTotal.valor_medio) * Math.round(featureTotal.superficie) * (this.eficiencia / 100) * (1 - this.perdidaTemp / 100) * (1 - this.perdidasGenerales / 100);
		const consumoEurosFiltrada = 12 * (consumoP1 * precioP1 + consumoP2 * precioP2 + consumoP3 * precioP3);
		const consumoEurosTotal = 12 * (consumoP1 * precioP1 + consumoP2 * precioP2 + consumoP3 * precioP3);

		let compensacionEurosFiltrada = 0;
		let compensacionEurosTotal = 0;
		let compensacionEnergiaFiltrada = 0;
		let compensacionEnergiaTotal = 0;

		const precioMedio = (precioP1 + precioP2 + precioP3) / 3;

		let ahorroAnualFiltrado = energiaProducidaFiltrada * precioMedio;
		let ahorroAnualTotal = energiaProducidaTotal * precioMedio;

		let ahorroConsumoFiltrado = energiaProducidaFiltrada * precioMedio;
		let ahorroConsumoTotal = energiaProducidaTotal * precioMedio;

		// Filtrada
		if (energiaProducidaFiltrada >= consumo) {
			compensacionEnergiaFiltrada = energiaProducidaFiltrada - consumo;
			compensacionEurosFiltrada = compensacionEnergiaFiltrada * precioComp;
			ahorroAnualFiltrado = consumoEurosFiltrada + compensacionEurosFiltrada;
			ahorroConsumoFiltrado = consumoEurosFiltrada;
		}

		// Total
		if (energiaProducidaTotal >= consumo) {
			compensacionEnergiaTotal = energiaProducidaTotal - consumo;
			compensacionEurosTotal = compensacionEnergiaTotal * precioComp;
			ahorroAnualTotal = parseInt(consumoEurosTotal) + parseInt(compensacionEurosTotal);
			ahorroConsumoTotal = parseInt(consumoEurosTotal);
		}

		let amortizacionFiltered = 0;
		let amortizacionTotal = 0;

		// Amortización 
		if (ahorroAnualFiltrado > 0)
			amortizacionFiltered = featureFiltered.price / ahorroAnualFiltrado;

		if (ahorroAnualTotal > 0)
			amortizacionTotal = featureTotal.price / ahorroAnualTotal;

		this.ahorroCompensacion = compensacionEurosFiltrada;
		this.amortizacion = amortizacionFiltered;

		return `
		<table class="table styled-table" id="tabla-economics">
			<thead>
				<tr>
					<th> Variable </th>
					<th> Filtrado </th>
					<th> Total </th>
				</tr>
			</thead>

			<tbody>
				<tr>
					<td> 
						<span id="inversion" class="tooltip-button">Inversión<i id="inversion-tippy" class="bi bi-info-circle-fill"></i></span>
					</td>
					<td>${this.parseTableValue(featureFiltered.price)} €</td>
					<td>${this.parseTableValue(featureTotal.price)} €</td>
				</tr>
				<tr>
					<td>
						<span id="energia">Energía anual generada</span>
					</td>
					<td>
						${this.parseTableValue(parseInt(energiaProducidaFiltrada))} kWh
					</td>
					<td>
						${this.parseTableValue(parseInt(energiaProducidaTotal))} kWh
					</td>
				</tr>
				<tr>
					<td class="position-relative">
						<div class="tooltip-button noselect"> <span id="ahorro-anual">Ahorro anual</span> </div>
					</td>
					<td>${this.parseTableValue(parseInt(ahorroAnualFiltrado))} €</td>
					<td>${this.parseTableValue(parseInt(ahorroAnualTotal))} €</td>
				</tr>
				<tr>
					<td class="position-relative">
						<div class="tooltip-button noselect"> <span id="ahorro-anual">Ahorro anual por consumo</span> </div>
					</td>
					<td>${this.parseTableValue(parseInt(ahorroConsumoFiltrado))} €</td>
					<td>${this.parseTableValue(parseInt(ahorroConsumoTotal))} €</td>
				</tr>
				<tr>
					<td class="position-relative">
						<div class="tooltip-button noselect"> <span id="ahorro-anual">Ahorro anual por compensación</span> </div>
					</td>
					<td id="ahorro-compensacion">${this.parseTableValue(parseInt(compensacionEurosFiltrada))} €</td>
					<td>${this.parseTableValue(parseInt(compensacionEurosTotal))} €</td>
				</tr>
				<tr>
					<td class="position-relative">
						<div class="tooltip-button noselect">
							<span id="ahorro-vidautil">Ahorro acumulado durante la vida útil<i id="ahorro-vidautil-tippy" class="bi bi-info-circle-fill"></i> </span>
						</div>
					</td>
					<td>${Utils.numberWithCommas(parseInt(((ahorroAnualFiltrado) * 25) - featureFiltered.price))} €</td>
					<td>${Utils.numberWithCommas(parseInt(((ahorroAnualTotal) * 25) - featureTotal.price))} €</td>
				</tr>
				<tr>
					<td class="position-relative">
						<div class="tooltip-button noselect">
							<span id="amortizacion">Periodo de amortización</span>
						</div>
					</td>
					<td id="amortizacion-anyos">${amortizacionFiltered.toFixed(1).replace('.', ',')} años</td>
					<td>${amortizacionTotal.toFixed(1).replace('.', ',')} años</td>
				</tr>
			</tbody>
		</table>
		`
	}
	searchCandidateCatastral(referencia_catastral) {

		// store it
		visor2D.referencia_catastral = referencia_catastral;
		// set loading
		set_loading(LOADING_CONTEXT_SEARCH, true);

		// clear map
		visor2D.map.getLayers().find(l => l.name === '__draw__').clear();

		// build call
		let body = {
			'inputs': {
				'entidad': 'puntos',
				'limite': 5,
				"percentil": 100,
				'referencia_catastral': [referencia_catastral]
			}
		};

		// get referencias catastrales list
		visor2D.pygeoapi(body, (response) => {
			// build candidates

			let html = '';
			if (response.error) {
				html = visor2D.no_results();
			} else {
				html = visor2D.referencia_catastral_item(body.inputs.referencia_catastral[0])
				visor2D.candidates_catastro = response.resultado.features;
			}

			set_loading(LOADING_CONTEXT_SEARCH, false);
		});

	}
	get_coordinates_center(coordinates) {
		if (coordinates.length === 0) {
			return null; // Return null for an empty list of coordinates
		}

		// Initialize variables to store the sum of x and y values
		let sumX = 0;
		let sumY = 0;

		// Iterate through the coordinates and accumulate the sum of x and y values
		coordinates.forEach(coord => {
			sumX += coord[0]; // Assuming x is the first element in the coordinate pair
			sumY += coord[1]; // Assuming y is the second element in the coordinate pair
		});

		// Calculate the average of x and y values
		const centerX = sumX / coordinates.length;
		const centerY = sumY / coordinates.length;

		// Return the center as an array [centerX, centerY]
		return [centerX, centerY];

	}
	reproject_feature(feature) {


		let proyected_coordinates = [];
		let flat_proyected_coordinates = [];

		// reproject coordinates and store flat ones to determine center point
		if (feature.geometry.type === 'Polygon') {
			proyected_coordinates = visor2D.transform_coordinates(feature.geometry.coordinates);
			flat_proyected_coordinates = flat_proyected_coordinates.concat(proyected_coordinates[0])
		} else if (feature.geometry.type === 'MultiPolygon') {
			for (const coordinates of feature.geometry.coordinates) {
				const current_proyected_coordinates = visor2D.transform_coordinates(coordinates);
				proyected_coordinates.push(current_proyected_coordinates);
				flat_proyected_coordinates = flat_proyected_coordinates.concat(current_proyected_coordinates[0])
			}
		}

		const center = visor2D.get_coordinates_center(flat_proyected_coordinates);

		const proyected_feature = {
			"type": "Feature",
			"geometry": {
				"type": feature.geometry.type,
				"coordinates": proyected_coordinates,
			},
			"center": center,
		}
		return proyected_feature;
	}
	searchByKml(kml) {
		const body = {
			"inputs": {
				"entidad": "edificios",
				"kml": kml,
				"limite": 50000
			}
		}
		visor2D.pygeoapi(body, (response) => {

			set_loading(LOADING_CONTEXT_SEARCH, false);

			if (response.error) {
				return;
			}

			if (body.inputs.entidad === 'puntos') {
				selection_plugin.toggle_points_tool_visibility(true);
				visor2D.current_rendering_mode = visor2D.RENDERING_POINTS
				visor2D.add_points(response, true);
			} else if (body.inputs.entidad === 'edificios') {
				selection_plugin.toggle_points_tool_visibility(false);
				visor2D.current_rendering_mode = visor2D.RENDERING_BUILDINGS;
				visor2D.add_buildings(response, visor2D.REPROJECT);
			}

			// filterSlider.reset();
			uncollapseSidebar();

		});
	}
	searchByPolygon(feature, render_polygon) {

		// store it
		visor2D.feature = feature;

		// clear the layer
		visor2D.map.getLayers().find(l => l.name === '__draw__').clear();

		if (render_polygon) {
			// reproyect
			const proyected_coordinates = visor2D.transform_coordinates(feature.geometry.coordinates);
			const drawed_feature = {
				"type": "Feature",
				"geometry": {
					"type": "Polygon",
					"coordinates": proyected_coordinates,
				}
			}
			visor2D.drawed_features.push(drawed_feature);
		}

		// build body with polygon data
		let bodies = visor2D.pygeoapiBodyByPolygon(feature);
		// add point, calls closest point to click
		if (!render_polygon) {
			const polygonCenter = visor2D.get_coordinates_center(feature.geometry.coordinates[0]);

			bodies = [{
				inputs: {
					entidad: 'punto',
					x_punto: polygonCenter[0],
					y_punto: polygonCenter[1],
				}
			}];
		}

		visor2D.render_drawed_polygons()


		for (const body of bodies) {
			// search by polygon
			if (render_polygon)
				visor2D.pygeoapi(body, (response) => {

					set_loading(LOADING_CONTEXT_SEARCH, false);

					if (response.error) {
						return;
					}

					if (body.inputs.entidad === 'puntos') {
						visor2D.add_points(response, true);
					} else if (body.inputs.entidad === 'edificios') {
						visor2D.add_buildings(response, visor2D.REPROJECT);
					}

					// filterSlider.reset();
					uncollapseSidebar();
				});
			else
				visor2D.pygeoapiClosestPoint(body, (response) => {
					set_loading(LOADING_CONTEXT_SEARCH, false);

					if (response.error) {
						return;
					}

					visor2D.add_points(response, true);
					uncollapseSidebar();
				});
		}

	}
	add_buildings(response, reproject) {

		if (visor2D.current_rendering_mode !== visor2D.RENDERING_BUILDINGS) {
			return;
		}

		let features = [];
		if (response) {

			visor2D.buildings_features_hashes = visor2D.buildings_features.map(e => {
				return Utils.hashDict(e)
			});
			for (const feature of response.resultado.features) {
				let current_building = [];
				const coordinates = feature.geometry.coordinates;

				if (reproject === visor2D.REPROJECT) {
					for (const coordinate of coordinates) {
						const proj_coordinates = visor2D.transform_coordinates(coordinate);
						current_building.push(proj_coordinates);
					}
				} else {
					current_building = coordinates;
				}

				const new_feature = {
					"type": "Feature",
					"geometry": {
						"type": "MultiPolygon",
						"coordinates": current_building
					},
					"properties": {
						"value_anual": feature.properties.valor_medio,
						"surface": feature.properties.superficie,
						"type": "solar-building"
					}
				};

				const current_hash = Utils.hashDict(new_feature);
				// if it is not repeated
				if (!visor2D.buildings_features_hashes.includes(current_hash)) {
					visor2D.buildings_features.push(new_feature);
					visor2D.buildings_features_hashes.push(current_hash);
					features.push(new_feature);
				} else {
					new_feature.properties.hidden = true;
				}
			}
		}


		const values = visor2D.buildings_features.map(dict => dict.properties.value_anual);
		const minValue = Math.min(...values);
		const maxValue = Math.max(...values);
		const avgValue = values.reduce((sum, value) => sum + value, 0) / values.length;
		let surface = features.reduce((sum, item) => sum + item.properties.surface, 0) * 1000;

		visor2D.current_table_data.superficie += surface;
		visor2D.current_table_data.valor_medio = avgValue;
		visor2D.current_table_data.valor_minimo = minValue;
		visor2D.current_table_data.valor_maximo = maxValue;
		visor2D.current_table_data.valor_total = avgValue * visor2D.current_table_data.superficie;

		let table_html = visor2D.getTableHTML(visor2D.current_table_data, visor2D.current_table_data);


		visor2D.filtro_content.removeClass("d-none");
		visor2D.sidebar_table.html(table_html);


		visor2D.loadVectorLayer(visor2D.buildings_features, "buildings", 1038);
	}
	add_points(response, loadLayer) {

		if (visor2D.current_rendering_mode !== visor2D.RENDERING_POINTS) {
			return;
		}

		if (response && selection_plugin.current_toggle_mode !== selection_plugin.SELECTION_MODE_SUBSTRACT) {

			visor2D.points_features_hashes = visor2D.points_features.map(e => {
				return Utils.hashDict(e.bbox)
			});


			let features = [];
			let spots = []

			for (const feature of response.resultado.features) {

				// If point is generated by WMS, set wms property to true so it does not render
				if (!loadLayer)
					feature.properties.wms = true;
				else
					feature.properties.wms = false;

				const spot = [...feature.geometry.coordinates];
				spots.push(spot);


				// dot to circle
				const size = .8;
				feature.bbox = [...spot, ...spot];

				let circle_point = new ol.geom.Point(spot);
				circle_point = circle_point.transform("EPSG:4326", "EPSG:3857");

				circle_point = circle_point.getCoordinates();


				feature.geometry.type = "Point";
				feature.geometry.coordinates = circle_point;



				const current_hash = Utils.hashDict(feature.bbox);
				// if it is not repeated
				if (!visor2D.points_features_hashes.includes(current_hash)) {
					feature.properties.hidden = false;
					visor2D.points_features.push(feature);
				} else {
					feature.properties.hidden = true;
				}


				features.push(feature);
			}

			// const [lat, lng] = findCenter(spots);
			//const [lat, lng] = ol.proj.transform(
			//	Utils.geometry.findCenter(spots),
			//	'EPSG:4326',
			//	'EPSG:3857',
			//);
			//visor2D.map.setCenter({ x: lat - 70, y: lng });
			//visor2D.map.setZoom(18);
		}


		const values = visor2D.points_features.map(dict => dict.properties.value_anual);
		const minValue = Math.min(...values);
		const maxValue = Math.max(...values);
		const avgValue = values.reduce((sum, value) => sum + value, 0) / values.length;

		// let percentage_superficie = (100 / (visor2D.points_features.length / features.length)) / 100;

		visor2D.current_table_data.superficie = visor2D.points_features.length * 4;
		visor2D.current_table_data.valor_medio = avgValue;
		visor2D.current_table_data.valor_minimo = minValue;
		visor2D.current_table_data.valor_maximo = maxValue;
		visor2D.current_table_data.valor_total = avgValue * visor2D.current_table_data.superficie;

		let table_html = visor2D.getTableHTML(
			visor2D.current_table_data, visor2D.current_table_data
		);


		visor2D.filtro_content.removeClass("d-none");
		visor2D.sidebar_table.html(table_html);

		visor2D.loadVectorLayer(visor2D.points_features.filter(e => !e.properties.wms), "points", 1040);
		visor2D.layers.vector_points.on(M.evt.SELECT_FEATURES, (f) => {
			visor2D.deleteFeatureDots(f);
		});

		if (visor2D.points_features.length > 0) {
			this.maximoRadiacion = this.points_features[0].properties.value_mes_1 / 1000;
		} else
			this.maximoRadiacion = 0;

		if (!$("#account-collapse").hasClass("show") && !$("#button-collapse4").hasClass("show") && !$("#button-collapse3").hasClass("show") && !$("#button-collapse2").hasClass("show")) {
			$("#account-collapse").collapse('show');
			$("#button-collapse4").click();
			$("#button-collapse3").click();
			$("#button-collapse2").click();
		}
	}
	pygeoapi(body, callback) {
		const url = config.pygeoapi.url + '/radiacion_solar/execution';

		let current_set_loading = true;
		if (body.inputs.referencia_catastral) {
			if (body.inputs.referencia_catastral.length === 1) {
				current_set_loading = false;
			}
		}
		if (current_set_loading) {
			set_loading(LOADING_CONTEXT_PAGE, true);
		}



		$.ajax({
			url: url,
			method: 'post',
			headers: {
				'authority': config.pygeoapi.authority,
				'accept': 'application/json'
			},
			contentType: 'application/json',
			data: JSON.stringify(body),
			timeout: 20000

		}).done(function (response) {

			callback(response, body);
			set_loading(LOADING_CONTEXT_PAGE, false);

		}).fail((jqXHR, textStatus, errorThrown) => {

			if (textStatus === 'timeout') {
				//console.log('Request timed out');
			} else {
				//console.error('Error: ' + errorThrown);
				M.dialog.info("Error de conexión con el servidor PyGeoAPI.");
			}
		});
	}
	pygeoapiClosestPoint(body, callback) {
		const url = config.pygeoapi.url + '/entidad_cercana/execution';

		let current_set_loading = true;
		if (body.inputs.referencia_catastral) {
			if (body.inputs.referencia_catastral.length === 1) {
				current_set_loading = false;
			}
		}
		if (current_set_loading) {
			set_loading(LOADING_CONTEXT_PAGE, true);
		}

		$.ajax({
			url: url,
			method: 'post',
			headers: {
				'authority': config.pygeoapi.authority,
				'accept': 'application/json'
			},
			contentType: 'application/json',
			data: JSON.stringify(body),
			timeout: 20000

		}).done(function (response) {

			callback(response, body);
			set_loading(LOADING_CONTEXT_PAGE, false);

		}).fail((jqXHR, textStatus, errorThrown) => {

			if (textStatus === 'timeout') {
				//console.log('Request timed out');
			} else {
				//console.error('Error: ' + errorThrown);
				M.dialog.info("Error de conexión con el servidor PyGeoAPI.");
			}
		});
	}
	pygeoapiUbicacionOptima(body, callback) {
		const url = config.pygeoapi.url + '/localizacion_optima/execution';
		set_loading(LOADING_CONTEXT_PAGE, true);

		$.ajax({
			url: url,
			method: 'post',
			headers: {
				'authority': config.pygeoapi.authority,
				'accept': 'application/json'
			},
			contentType: 'application/json',
			data: JSON.stringify(body),
			timeout: 20000

		}).done(function (response) {

			callback(response, body);
			set_loading(LOADING_CONTEXT_PAGE, false);

		}).fail((jqXHR, textStatus, errorThrown) => {

			if (textStatus === 'timeout') {
				//console.log('Request timed out');
			} else {
				//console.error('Error: ' + errorThrown);
				M.dialog.info("Error de conexión con el servidor PyGeoAPI.");
			}
		});
	}
	pygeoapiBodyByGeojson(features) {
		return features.map(feature => {
			return {
				"inputs": {
					"entidad": "edificios",
					"geojson": {
						"features": feature
					},
					"limite": 1000
				}
			}
		}
		)
	}
	pygeoapiBodyByPolygon(feature) {


		let body = {
			inputs: {
				entidad: 'puntos',
				limite: 50000,
				percentil: 100,
				geojson: {
					"features": [
						feature
					],
					"type": "FeatureCollection",
				}
			},
		};


		const previous_rendering_mode = visor2D.current_rendering_mode;
		if (feature.properties.area) {
			if (feature.properties.area.m > 10_000) {
				body.inputs.entidad = "edificios";
				if (visor2D.current_rendering_mode !== visor2D.RENDERING_BUILDINGS) {
					visor2D.map.removeLayers(visor2D.layers.radiacion_solar_puntos);
					M.dialog.info("Area muy grande, se mostrarán edificios en vez de puntos.");
				}
			}
		}
		if (visor2D.current_rendering_mode === visor2D.RENDERING_BUILDINGS) {
			body.inputs.entidad = "edificios";
		}



		// set rendering mode
		// from points, it can be changed to buldings, not vice versa
		if (body.inputs.entidad === 'puntos') {
			selection_plugin.toggle_points_tool_visibility(true);
			visor2D.current_rendering_mode = visor2D.RENDERING_POINTS;
		} else if (body.inputs.entidad === 'edificios') {

			if (visor2D.current_rendering_mode === visor2D.RENDERING_POINTS) {
				// if it previously was POINT, but now is BUILDING
				visor2D.current_rendering_mode = visor2D.RENDERING_BUILDINGS;
				selection_plugin.toggle_points_tool_visibility(false);
				visor2D.points_features = [];
				// clear points
				visor2D.loadVectorLayer([], "points", 1040);
				visor2D.layers.vector_points.on(M.evt.SELECT_FEATURES, (f) => {
					visor2D.deleteFeatureDots(f);
				});
			}

		}



		if (visor2D.current_rendering_mode === visor2D.RENDERING_BUILDINGS) {
			body.inputs.entidad = "edificios";
		}

		if (visor2D.current_rendering_mode === visor2D.RENDERING_POINTS) {
			visor2D.drawed_features_points.push(feature);
		}

		let bodies = [body];
		// transaction from points to building
		if (previous_rendering_mode === visor2D.RENDERING_POINTS && visor2D.current_rendering_mode === visor2D.RENDERING_BUILDINGS) {

			for (const feature of visor2D.drawed_features_points) {
				bodies.push(
					visor2D.pygeoapiBodyByPolygon(feature)[0]
				);
			}
			visor2D.drawed_features_points = [];

		}



		return bodies;
	}
	loadVectorLayer(features, layer_name, zindex) {

		layer_name = "vector_" + layer_name;


		// remove if exist
		if (visor2D.layers[layer_name]) {
			visor2D.map.removeLayers(visor2D.layers[layer_name]);
		}

		visor2D.layers[layer_name] = new M.layer.GeoJSON(
			new M.layer.GeoJSON({
				name: layer_name,
				source: {
					"type": "FeatureCollection",
					"features": features,
					"totalFeatures": 2,
					"numberReturned": 1,
					// "timeStamp": "2022-10-04T07:15:29.726Z",
					"crs": {
						"type": "name",
						"properties": {
							"name": "urn:ogc:def:crs:EPSG::3857"
						}
					},
					"bbox": [
						-408144.8649,
						4933693.6859,
						-408063.3298,
						4933765.2887
					]
				}
			})
		);
		visor2D.layers[layer_name].setZIndex(zindex);
		visor2D.layers[layer_name].on(
			M.evt.LOAD,
			function (features) {
				visor2D.last_features = features;
				visor2D.setVectorStyles(filterSlider.watios);
			},
			visor2D
		);
		visor2D.map.addLayers(visor2D.layers[layer_name]);
	}
	referencia_catastral_item(value) {
		if (!value) return '';

		return `
<div
	class="address d-flex align-items-center"
	data-catastro="${value}"
>
	<i class="bi bi-geo-alt-fill px-2 fs-5" width="16px"></i>
	<span>
		<span class="capitalize">${value}</span>
	</span>
</div>`;
	}
	no_results() {
		return `<div class="not-address d-flex align-items-center justify-content-center py-3"
	<span>
		<span class="text-black-50">No se han encontrado resultados...</span>
	</span>
</div>`;
	}
	calcularCosteInstalacion(superficie) {

		const costeBase = 1501;
		const paneles = superficie / (this.largoPanel * this.anchoPanel);

		const costeDia = this.costeManoObra * 8;
		const panelesDia = 1.36;
		const dias = paneles / panelesDia;
		const costeManoObra = costeDia * dias;

		const costePaneles = (this.costePaneles + 297) * paneles; // 297 es el coste asociado a los paneles (estructuras, cables...)

		return parseInt(costeBase + costeManoObra + costePaneles);
	}
}